import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  Button,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Badge,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import {
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Info as InfoIcon,
  Badge as BadgeIcon,
  LocationOn as LocationIcon,
  CalendarToday as CalendarIcon,
  Description as DescriptionIcon,
  Assessment as AssessmentIcon,
  Visibility as ViewIcon,
  Edit as EditIcon,
  ExpandMore as ExpandMoreIcon,
  Person2Outlined,
  AccountBalance as FeesIcon,
  Receipt as ReceiptIcon,
  Error as ErrorIcon,
  Payment as PaymentIcon,
  Cancel as CancelIcon,
  AccessTime as AccessTimeIcon,
  Update as UpdateIcon,
  Description as ReportIcon,
  Reply as ReplyIcon,
  CloudUpload as CloudUploadIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { LoaderWrapper, TerminateApplicationDialog } from "./index";
import { getDashboardData, getDashboardDataNew, getLabName, getAnnualFee, getAssessmentTypes } from "../services/api";
import { encryptAppId, encryptText } from "../utils/encryption";
import PreviewReportPDFViewer from "./PreviewReportPDFViewer";
import usePreviewReport from "../hooks/usePreviewReport";
import DoApiService from "../services/DoApiService";
import paymentService from "../services/paymentService";
import FeesService from "../services/feesService";
import UnfreezeApiService from "../services/UnfreezeApiService";
import accountsApiService from "../services/accountsApiService";
import { generateCommunicationLetter } from "./certificate/CommunicationLetterGenerator";
import { generateDecisionLetter } from "./certificate/DecisionLetterGenerator";

import FileUploadComponent from "./FileUploadComponent";
import s3Utils from "../utils/s3Utils";
import AssessorDetailsView from "../pages/JD/application/AssessorDetailsView";
import ReportsDetails from "../pages/Do/application/ReportsDetails";

// Simple encryption for URL parameters
const encryptData = (data) => {
  try {
    const jsonString = JSON.stringify(data);

    return btoa(
      unescape(encodeURIComponent(jsonString))
    )
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");

  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
const DashboardPage_new = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardDataNew, setDashboardDataNew] = useState([]);
  const [labData, setLabData] = useState(null);
  const [error, setError] = useState("");
  const [assessmentDates, setAssessmentDates] = useState([]);
  const [expandDates, setExpandDates] = useState(false);
  const [expandDatesAppId, setExpandDatesAppId] = useState(null);
  const [dealingOfficer, setDealingOfficer] = useState(null);
  const [contactPersons, setContactPersons] = useState([]);
  const [openOfficerDialog, setOpenOfficerDialog] = useState(false);
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [unfreezeRecords, setUnfreezeRecords] = useState([]);
  const [assessorsData, setAssessorsData] = useState([]);
  // Per-application data maps (keyed by AppId)
  const [paymentDetailsMap, setPaymentDetailsMap] = useState({});
  const [unfreezeRecordsMap, setUnfreezeRecordsMap] = useState({});
  const [assessmentFeesMap, setAssessmentFeesMap] = useState({});
  const [ptPlanDataMap, setPtPlanDataMap] = useState({});
  const [appDetailsMap, setAppDetailsMap] = useState({});
  const [annualFeesMap, setAnnualFeesMap] = useState({});
  const [assessmentDatesMap, setAssessmentDatesMap] = useState({});
  const [feesData, setFeesData] = useState({
    appId: null,
    feesBreakdown: [],
    summary: {
      grossTotal: 0,
      gstRate: 18,
      gstAmount: 0,
      grandTotal: 0,
    },
  });
  // Assessment fees eligibility state
  const [assessmentFeesEligibility, setAssessmentFeesEligibility] = useState({
    showPayAssessmentFeesButton: false,
    loading: false,
    conditions: null,
  });
  // Annual fees state
  const [annualFeesData, setAnnualFeesData] = useState(null);
  const [showAnnualFeesButton, setShowAnnualFeesButton] = useState(false);
  // Communication letter data
  const [applicationData, setApplicationData] = useState(null);
  // PT Plan data
  const [uploadedPtPlanFile, setUploadedPtPlanFile] = useState(null);
  const [ptPlanUploaded, setPtPlanUploaded] = useState(false);
  const [ptPlanModalOpen, setPtPlanModalOpen] = useState(false);
  const [fileUploadKey, setFileUploadKey] = useState(0);
  const [selectedPtPlanFile, setSelectedPtPlanFile] = useState(null);
  const [ptPlanUploading, setPtPlanUploading] = useState(false);
  const [pdfTriggered, setPdfTriggered] = useState(false);
  // PDF Viewer state
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  // Additional Application Dialog states
  const [openAdditionalAppDialog, setOpenAdditionalAppDialog] = useState(false);
  const [selectedApplicationType, setSelectedApplicationType] = useState('');
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [password, setPassword] = useState('');
  const [assessmentTypes, setAssessmentTypes] = useState([]);
  const [assessmentTypesLoading, setAssessmentTypesLoading] = useState(false);
  const [showAdditionalAppButton, setShowAdditionalAppButton] = useState(false);
  const [creatingApplication, setCreatingApplication] = useState(false);
  const [username, setUsername] = useState('');
  const [outstandingPopupOpen, setOutstandingPopupOpen] = useState(false);
  const [outstandingPopupData, setOutstandingPopupData] = useState([]);
  const [outstandingPopupTotal, setOutstandingPopupTotal] = useState(0);
  const [outstandingPaymentLoading, setOutstandingPaymentLoading] = useState(false);

  // Dialog states for AssessorDetailsView and ReportsDetails
  const [assessorDialogOpen, setAssessorDialogOpen] = useState(false);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [paymentsDialogOpen, setPaymentsDialogOpen] = useState(false);
  const [form131DialogOpen, setForm131DialogOpen] = useState(false);
  const [form131Data, setForm131Data] = useState([]);
  const [dialogAppId, setDialogAppId] = useState(null);
  const [dialogOrgId, setDialogOrgId] = useState(null);
  const [dialogStage, setDialogStage] = useState('');
  const [dialogLabTypeId, setDialogLabTypeId] = useState('');

  const {
    loading: pdfLoading,
    error: pdfError,
    pdfUrl,
    fetchPreviewReport,
    fetchForm131Report,
    generatePreviewReport,
    openInNewTab,
    downloadPDF,
    resetState: resetPdfState,
  } = usePreviewReport();

  const handleOpenOfficerDialog = () => setOpenOfficerDialog(true);
  const handleCloseOfficerDialog = () => setOpenOfficerDialog(false);
  const handleOpenContactDialog = () => setOpenContactDialog(true);
  const handleCloseContactDialog = () => setOpenContactDialog(false);

  // Get user info from localStorage (only orgId, appId will come from selected application)
  const orgIdFromStorage = localStorage.getItem("orgId") || "";

  // Use selected application's IDs or fallback to empty strings
  const orgId = orgIdFromStorage || "";


  const loadAssessorAllotmentData = useCallback(async (application) => {
    if (!application?.AppId) {
      setError("Invalid application ID. Please check the URL.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Call API to get assessor allotment details (mode 5 - AssessorAllotment_New)
      const response = await DoApiService.getAssessorAllotmentDetails9({
        mode: 64,
        appId: parseFloat(application?.AppId),
      });

      if (response.success) {
        setAssessorsData(response.data || []);
        // Log capacity information for debugging
        response.data?.forEach((assessor, index) => {
          console.log(`Assessor ${index + 1}:`, {
            name: assessor.assessorName || assessor.name,
            id: assessor.allotedToId,
            capacity: assessor.capacity,
            fullData: assessor
          });
        });
      } else {
        throw new Error(response.message || "Failed to load assessor allotment details");
      }
    } catch (err) {
      setError(`Error loading assessor allotment details: ${err.message}`);
      console.error("Load assessor allotment error:", err);
      // Set empty data on error
      setAssessorsData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load payment details
  const loadPaymentDetails = async (application) => {
    if (!application?.AppId) return;
    try {
      const response = await paymentService.checkPaymentStatus(application.OrgId, application.AppId);
      setPaymentDetails(response.data);
      console.log('payment data', response.data);
    } catch (error) {
      console.error("Error loading payment details:", error);
      setPaymentDetails(prev => ({ ...prev, [application.AppId]: null }));
    }
  };

  // Check additional application eligibility
  const checkAdditionalApplicationEligibility = async (orgId) => {
    if (!orgId) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/change-name-app/check-additional-application`,
        { OrgId: orgId }
      );

      if (response.data.success && response.data.data) {
        const { stage, labTypeId } = response.data.data;
        const shouldShow = ['7d', '14', '2e', '15d'].includes(stage) && labTypeId === 3;
        setShowAdditionalAppButton(shouldShow);
      } else {
        setShowAdditionalAppButton(false);
      }
    } catch (error) {
      console.error("Error checking additional application eligibility:", error);
      setShowAdditionalAppButton(false);
    }
  };

  const checkAndHandleUnfreeze = async (application, records) => {
    if (!application) return;
    if (!records || records.length === 0) return;

    let shouldRedirect = false;

    for (const record of records) {
      const pdfGenerated = record.pdfGenerate;
      const pdfGeneratedDate = record.pdfGenerateDate
        ? new Date(record.pdfGenerateDate)
        : null;
      const expiryDate = record.expirydate
        ? new Date(record.expirydate)
        : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (expiryDate <= today) {
        if ((pdfGenerated !== 1 || pdfGenerated === null) && (expiryDate > pdfGeneratedDate)) {
          shouldRedirect = true;
          break;
        }
      } else {
        console.log('no pdf required')
      }


    }

    if (shouldRedirect && !pdfTriggered) {
      try {
        setPdfTriggered(true);

        console.log("🚀 Calling pdfInsert API...");

        await UnfreezeApiService.pdfRecordInsert(application?.AppId, application?.OrgId);

        console.log("🔁 Redirecting to preview report...");

        handlePreviewClickfordownload(application?.AppId, application?.OrgId); // ✅ MOVE HERE

      } catch (error) {
        console.error("Error:", error);
      }
    }
  };


  // Load unfreeze records
  const loadUnfreezeRecords = useCallback(async (application) => {
    if (!application?.AppId) return;

    try {
      const response = await UnfreezeApiService.getUnfreezeRecords(
        application.AppId,
        application.OrgId,
      );
      if (response.success) {
        const responsedata = response.data || [];
        setUnfreezeRecordsMap(prev => ({ ...prev, [application.AppId]: responsedata }));
        // Keep global state in sync for first application (used by checkAndHandleUnfreeze)
        setUnfreezeRecords(responsedata);
        setTimeout(() => {
          checkAndHandleUnfreeze(application, responsedata);
        }, 0);
      }
    } catch (err) {
      console.error("Load unfreeze records error:", err);
    }
  }, [pdfTriggered]);


  const formatCurrency = (amount) => {
    return FeesService.formatCurrency(amount);
  };
  // Load dealing officer details (mode 31)
  const loadDealingOfficer = useCallback(async (application) => {
    const appId = application?.AppId ?? application;
    if (!appId) return;

    try {
      const response = await DoApiService.getAllotmentDetails({
        mode: 31,
        appId: parseFloat(appId),
      });

      if (response.success && response.data.length > 0) {
        setDealingOfficer(response.data[0]); // Take first officer
      }
    } catch (err) {
      console.error("Load dealing officer error:", err);
    }
  }, []);

  // Load contact person details (mode 27)
  const loadContactPerson = useCallback(async (application) => {
    const appId = application?.AppId ?? application;
    if (!appId) return;

    try {
      const response = await DoApiService.getAllotmentDetails({
        mode: 27,
        appId: parseFloat(appId),
      });

      if (response.success && response.data.length > 0) {
        setContactPersons(response.data); // Store all contact persons (lab head + CEO details)
      }
    } catch (err) {
      console.error("Load contact person error:", err);
    }
  }, []);

  // Load assessment fees eligibility
  const loadAssessmentFeesEligibility = useCallback(async (application) => {

    if (!application?.AppId) return;

    try {
      const response =
        await accountsApiService.checkAssessmentFeesEligibility(application.AppId);

      if (response.success) {
        setAssessmentFeesMap(prev => ({
          ...prev,
          [application.AppId]: {
            showPayAssessmentFeesButton: response.data.showPayAssessmentFeesButton,
            conditions: response.data.conditions,
          }
        }));
      } else {
        setAssessmentFeesMap(prev => ({
          ...prev,
          [application.AppId]: { showPayAssessmentFeesButton: false, conditions: null }
        }));
      }
    } catch (err) {
      console.error("Load assessment fees eligibility error:", err);
      setAssessmentFeesMap(prev => ({
        ...prev,
        [application.AppId]: { showPayAssessmentFeesButton: false, conditions: null }
      }));
    }
  }, []);

  // Fetch applications array on mount
  const checkOutstanding = async () => {
    if (localStorage.getItem('outstandingSkipped') === 'true') return;
    try {
      const uname = localStorage.getItem('username') || '';
      if (!uname) return;
      const response = await accountsApiService.getOutstandingAmount(uname);
      const rows = response.value || [];
      const unpaid = rows.filter(row => row.PaymentStatus !== 'Paid' && (row.BillOpeningBalance || 0) >= 0);
      if (unpaid.length > 0) {
        const netTotal = rows.reduce((sum, row) => sum + (row.BillClosingBalance || 0), 0);
        setOutstandingPopupData(rows);
        setOutstandingPopupTotal(netTotal);
        setOutstandingPopupOpen(true);
      }
    } catch (err) {
      console.error('Error checking outstanding amount:', err);
    }
  };

  const handleSkipOutstanding = () => {
    localStorage.setItem('outstandingSkipped', 'true');
    setOutstandingPopupOpen(false);
  };

  const handlePayOutstanding = async () => {
    const encryptusername = encryptText(localStorage.getItem('username'))
    navigate(`/main/outstanding-ledger?username=${encryptusername}`)
  };

  useEffect(() => {
    const fetchApplications = async () => {
      if (!orgIdFromStorage) {
        toast.error(
          "Organization information not found. Please login again.",
        );
        navigate("/main/login");
        return;
      }

      try {
        setLoading(true);
        const [response, labNameResponse] = await Promise.all([
          getDashboardDataNew(orgIdFromStorage),
          getLabName(orgIdFromStorage)
        ]);

        if (response.data.success && response.data.data && response.data.data.length > 0) {
          setDashboardDataNew(response.data.data);

          // Check additional application eligibility
          checkAdditionalApplicationEligibility(orgIdFromStorage);

          // Load data for each application
          response.data.data.forEach(application => {
            loadPaymentDetails(application);
            loadUnfreezeRecords(application);
            loadAssessmentFeesEligibility(application);
            loadApplicationDetails(application.AppId);
            fetchPTPlan(application);
            loadAnnualFees(application);
            loadAssessmentDates(application);
          });

          // Load dealing officer and contact person for first application
          loadDealingOfficer(response.data.data[0]);
          loadContactPerson(response.data.data[0]);
        } else {
          toast.error("No applications found for this organization.");
          setDashboardDataNew([]);
        }

        // Set lab data if available
        if (labNameResponse.data.success) {
          setLabData(labNameResponse.data.data);
        } else {
          console.warn("Lab name not found:", labNameResponse.data.message);
        }
      } catch (error) {
        console.error("Error fetching applications:", error);
        toast.error("Failed to fetch applications");
      } finally {
        setLoading(false);
      }
    };
    fetchApplications();
    checkOutstanding();
  }, [orgIdFromStorage, navigate]);

  const getOrgId = () => {
    return orgIdFromStorage || "";
  };

  // Handle preview report button click - Enhanced with PDF viewer
  const handlePreviewReport = async (application) => {
    const currentOrgId = application?.OrgId;
    const currentAppId = application?.AppId;

    if (!currentOrgId || !currentAppId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      resetPdfState();
      const result = await fetchPreviewReport(currentAppId, "PreviewReport");

      if (result.success) {
        // Open in embedded PDF viewer
        setPdfViewerOpen(true);
        toast.success("Preview report loaded successfully");
      } else if (result.notFound) {
        toast.info(
          'No preview report available. Generate one using the "Generate Preview Report" button.',
        );
      } else {
        toast.error(result.error || "Failed to fetch preview report");
      }
    } catch (error) {
      console.error("Error fetching preview report:", error);
      toast.error("Error accessing preview report. Please try again.");
    }
  };

  const handleClickViewTerm = async (application) => {
    const headName = encodeURIComponent(application?.HeadName || "");
    const designation = encodeURIComponent(application?.Designation || "");
    const acceptanceDate = encodeURIComponent(
      new Date(application?.acceptancedate).toLocaleDateString()
    );

    window.open(
      `/main/termsandConditionsview?headName=${headName}&designation=${designation}&acceptanceDate=${acceptanceDate}`,
      "_blank"
    );
  };
  // Handle preview report in new tab
  const handlePreviewReportNewTab = async (application) => {
    const currentOrgId = application?.OrgId;
    const currentAppId = application?.AppId;

    if (!currentOrgId || !currentAppId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      const result = await fetchPreviewReport(currentAppId, "PreviewReport");

      if (result.success && result.url) {
        openInNewTab(result.url);
      } else if (result.notFound) {
        toast.info("No preview report available. Generate one first.");
      } else {
        toast.error(result.error || "Failed to fetch preview report");
      }
    } catch (error) {
      console.error("Error fetching preview report:", error);
      toast.error("Error accessing preview report. Please try again.");
    }
  };
  const handleForm131NewTab = async (application) => {
    const currentOrgId = application?.OrgId;
    const currentAppId = application?.AppId;

    if (!currentOrgId || !currentAppId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      const result = await fetchForm131Report(currentAppId);

      setForm131Data(result.data)
    } catch (error) {
      console.error("Error fetching preview report:", error);
      toast.error("Error accessing preview report. Please try again.");
    }
  };

  // Handle download preview report
  const handleDownloadPreviewReport = async (application) => {
    const currentOrgId = application?.OrgId;
    const currentAppId = application?.AppId;

    if (!currentOrgId || !currentAppId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      const result = await fetchPreviewReport(currentAppId, "PreviewReport");

      if (result.success && result.url) {
        await downloadPDF(
          result.url,
          `PreviewReport_${currentAppId}_${new Date().toISOString().split("T")[0]}.pdf`,
        );
        toast.success("Preview report download started");
      } else if (result.notFound) {
        toast.info("No preview report available. Generate one first.");
      } else {
        toast.error(result.error || "Failed to fetch preview report");
      }
    } catch (error) {
      console.error("Error downloading preview report:", error);
      toast.error("Error downloading preview report. Please try again.");
    }
  };

  // Handle generate preview report button click - Enhanced
  const handleGeneratePreviewReport = async (application) => {
    const currentOrgId = application?.OrgId;
    const currentAppId = application?.AppId;

    if (!currentOrgId || !currentAppId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      toast.info("Generating preview report... This may take a few moments.");

      // Get lab type from dashboard data or use default
      const labTypeId = application?.LabTypeId || "1";

      const result = await generatePreviewReport(
        currentOrgId,
        currentAppId,
        labTypeId,
        false,
      );

      if (result.success) {
        toast.success("Preview report generated successfully!");
        // Automatically open in PDF viewer
        setPdfViewerOpen(true);
      } else {
        toast.error(result.error || "Failed to generate preview report");
      }
    } catch (error) {
      console.error("Error generating preview report:", error);
      toast.error("Error generating preview report. Please try again.");
    }
  };

  // Removed automatic preview report call - let users click manually
  // useEffect (() => {
  //   handlePreviewReport();
  // }, []);
  const handleObservationClick = (application) => {
    if (!application?.AppId || !application?.OrgId) {
      console.error("AppId or OrgId not available for audit trail");
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(application.AppId.toString());
      const encryptedOrgIdParam = encryptText(application.OrgId.toString());
      const encryptedObservation = encryptText("true");

      // Navigate to audit trail page with encrypted parameters
      const url = `/main/preview-report?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&observation=${encryptedObservation}`;

      window.open(url, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error encrypting parameters for audit trail:", error);
    }
  };
  const handlePreviewClick = (application) => {
    if (!application?.AppId || !application?.OrgId) {
      console.error("AppId or OrgId not available for audit trail");
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(application.AppId.toString());
      const encryptedOrgIdParam = encryptText(application.OrgId.toString());
      const encryptedObservation = encryptText("false");

      // Navigate to audit trail page with encrypted parameters
      const url = `/main/preview-report?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&observation=${encryptedObservation}`;

      window.open(url, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error encrypting parameters for audit trail:", error);
    }
  };

  const handlePreviewClickfordownload = (application) => {
    if (!application?.AppId || !application?.OrgId) {
      console.error("AppId or OrgId not available for audit trail");
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(application.AppId.toString());
      const encryptedOrgIdParam = encryptText(application.OrgId.toString());
      const encryptedObservation = encryptText("false");

      // Navigate to audit trail page with encrypted parameters
      const url = `/main/preview-report?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&observation=${encryptedObservation}&autoDownload=true&fromSubmission=true`;

      navigate(url);
    } catch (error) {
      console.error("Error encrypting parameters for audit trail:", error);
    }
  };

  const handlePayAssessmentFees = (application) => {
    if (!application?.AppId || !application?.OrgId) {
      console.error("AppId or OrgId not available for payment");
      return;
    }

    try {
      // You can navigate to the payment page or open a payment modal
      // For now, I'll navigate to a payment page with encrypted parameters
      const encryptedAppIdParam = encryptAppId(application.AppId.toString());
      const encryptedOrgIdParam = encryptText(application.OrgId.toString());
      const encryptedApplicationNo = encryptText(
        application?.ApplicationNo || "",
      );

      // Navigate to payment page (adjust the route as needed)
      navigate(
        `/main/assessment-fees-payment?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&applicationNo=${encryptedApplicationNo}`,
      );
    } catch (error) {
      console.error("Error navigating to payment page:", error);
      toast.error("Error navigating to payment page");
    }
  };
  const handlePayAnnualFees = (application) => {
    if (!application?.AppId || !application?.OrgId) {
      console.error("AppId or OrgId not available for payment");
      return;
    }

    try {
      // You can navigate to the payment page or open a payment modal
      // For now, I'll navigate to a payment page with encrypted parameters
      const encryptedAppIdParam = encryptAppId(application.AppId.toString());
      const encryptedOrgIdParam = encryptText(application.OrgId.toString());
      const encryptedApplicationNo = encryptText(
        application?.ApplicationNo || "",
      );
      const encryptedPaymentType = encryptText("7");
      localStorage.setItem('paymenttype', '7');
      // Navigate to payment page (adjust the route as needed)
      navigate(
        `/main/medical/payment?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&applicationNo=${encryptedApplicationNo}&paymentType=${encryptedPaymentType}`,
      );
    } catch (error) {
      console.error("Error navigating to payment page:", error);
      toast.error("Error navigating to payment page");
    }
  };

  // Helper function to check if any unfreeze record has expiry date greater than today
  const hasValidUnfreezeRecord = (application) => {
    const records = (application?.AppId ? unfreezeRecordsMap[application.AppId] : null) || unfreezeRecords;
    if (!records || records.length === 0) {
      console.log("📋 No unfreeze records found");
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of day for accurate comparison

    const validRecords = records.filter((record) => {
      // Check if record has required fields
      if (!record || !record.expirydate) {
        console.log("⚠️ Record missing expiry date:", record);
        return false;
      }

      try {
        const expiryDate = new Date(record.expirydate);

        // Check if date is valid
        if (isNaN(expiryDate.getTime())) {
          console.log("⚠️ Invalid expiry date:", record.expirydate);
          return false;
        }

        expiryDate.setHours(0, 0, 0, 0); // Set to start of day for accurate comparison

        const isValid = expiryDate > today;

        console.log("📅 Checking unfreeze record:", {
          sectionname: record.sectionname,
          expirydate: record.expirydate,
          expiryDateFormatted: expiryDate.toDateString(),
          todayFormatted: today.toDateString(),
          isValid: isValid,
        });

        return isValid;
      } catch (error) {
        console.error("❌ Error parsing expiry date:", error, record);
        return false;
      }
    });

    const hasValid = validRecords.length > 0;
    console.log(
      `✅ Has valid unfreeze records: ${hasValid} (${validRecords.length}/${records.length})`,
    );

    if (hasValid) {
      console.log(
        "🔓 Edit Application button will be shown due to valid unfreeze records",
      );
    }

    return hasValid;
  };

  const handleEditApplication = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      // Encrypt the parameters for secure URL transmission
      const encryptedAppId = encryptAppId(appId.toString());
      const encryptedOrgId = encryptText(orgId.toString());

      console.log(
        "🔐 DashboardPage - Encrypting edit application parameters:",
        {
          originalAppId: appId,
          originalOrgId: orgId,
          encryptedAppId: encryptedAppId,
          encryptedOrgId: encryptedOrgId,
        },
      );
      const getBasePath = (labTypeId) => {
        switch (labTypeId) {
          case 3:
            return "medical";
          case 2:
            return "calibration"; // ✅ FIXED (was wrong before)
          case 1:
            return "testing";
          default:
            return null;
        }
      };

      const basePath = getBasePath(application.LabTypeId);

      if (!basePath) {
        toast.error("No Application Id Found");
        return;
      }

      let path = "";

      // AssessmentType conditions
      if ([11, 12].includes(application.AssessmentTypeId)) {
        path = "lab-staff-additional";
      } else if ([5, 13, 17].includes(application.AssessmentTypeId)) {
        path = "discipline";
      } else {
        path = "laboratory-details";
      }

      const editUrl = `/main/${basePath}/${path}?orgId=${encodeURIComponent(encryptedOrgId)}&appId=${encodeURIComponent(encryptedAppId)}`;

      window.open(editUrl, "_blank");
      toast.success("Opening application editor in new tab");
    } catch (error) {
      console.error("Error encrypting edit application parameters:", error);
      toast.error("Failed to encrypt parameters");
      // Fallback to unencrypted if encryption fails
      const fallbackUrl = `/main/medical/laboratory-details?orgId=${orgId}&appId=${appId}`;
      window.open(fallbackUrl, "_blank");
    }
  };

  const handleChooseAssessmentDate = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    // Get lab information from dashboard data
    const labName = labData?.labName || labData?.labName || "-";
    const labType = getLabTypeName(application?.LabTypeId) || "-";
    const labId = application?.labId || "-";
    const standard = application?.Standard || "-";

    console.log('encrypted date ', appId,
      orgId,
      labName,
      labType,
      labId,
      standard)
    // Encrypt the data before sending
    const dataToEncrypt = {
      appId,
      orgId,
      labName,
      labType,
      labId,
      standard
    };
    const encryptedData = encryptData(dataToEncrypt);

    if (!encryptedData) {
      toast.error("Failed to encrypt data");
      return;
    }

    // Navigate to assessment date selection page with encrypted data
    navigate(`/main/choose-assessment-date?data=${encryptedData}`);
  };
  const handleILacReport = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    // Get lab information from dashboard data
    const labName = labData?.labName || labData?.labName || "-";
    const labType = getLabTypeName(application?.LabTypeId) || "-";
    const labId = application?.labId || "-";
    const standard = application?.Standard || "-";
    // Encrypt the data before sending
    const dataToEncrypt = {
      appId,
      orgId,
      labName,
      labType,
      labId,
      standard
    };
    const encryptedData = encryptData(dataToEncrypt);

    if (!encryptedData) {
      toast.error("Failed to encrypt data");
      return;
    }

    // Navigate to assessment date selection page with encrypted data
    navigate(`/main/ilacReport?data=${encryptedData}`);
  };
  const handleAssessmentDetails = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    // Get lab information from dashboard data
    const labName = labData?.labName || labData?.labName || "";
    const labType = getLabTypeName(application?.LabTypeId) || "";
    const labId = application?.labId || "";

    // Encrypt the data before sending
    const encryptedorgid = encryptText(orgId.toString());
    const encryptedappid = encryptAppId(appId.toString());
    const pass = encryptText("true");
    if (!encryptedorgid) {
      toast.error("Failed to encrypt data");
      return;
    }

    // Navigate to assessment date selection page with encrypted data
    navigate(
      `/main/cab-accept-assessors?appId=${encryptedappid}&orgId=${encryptedorgid}&p=${pass}`,
    );
  };
  const handleAdditionalDocument = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const encryptedLab = encryptText("Lab");
    const encryptedorgid = encryptText(application.OrgId.toString());
    const encryptedappid = encryptAppId(application.AppId.toString());
    navigate(
      `/main/application/additional-documents?type=${encryptedLab}&appId=${encryptedappid}&orgId=${encryptedorgid}`,
    );
  };


  const handleViewPayments = async (application) => {
    try {
      const appId = application.AppId;
      const orgId = application.OrgId;

      console.log("Clicked AppId:", appId);
      console.log("Clicked OrgId:", orgId);

      setPaymentsDialogOpen(true);
      setPaymentLoading(true);

      const response = await paymentService.checkPaymentStatus(orgId, appId);

      setPaymentDetails(response.data || []);
    } catch (error) {
      console.error("Payment API Error:", error);
      toast.error("Failed to load payment details");
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleAdvisoryDetails = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;
    try {
      const encryptedAppId = encryptAppId(appId.toString());
      const encryptedOrgId = encryptText(orgId.toString());
      const updateUrl = `/main/laboratory/advisory?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${application?.LabTypeId || "3"}`;
      navigate(updateUrl);
    } catch (error) {
      console.error("Error encrypting laboratory update parameters:", error);
    }
  };

  // Load application details for communication letter
  const loadApplicationDetails = async (appId) => {
    if (!appId) return null;
    try {
      const [appDetailsResponse, labHeadResponse, doResponse] =
        await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_URL}/ac-process/application/details/${appId}`,
          ),
          axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
            params: { mode: 27, appId: appId },
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
            params: { mode: 31, appId: appId },
          }),
        ]);

      const appData = appDetailsResponse.data?.data || {};
      const labHeadData = labHeadResponse.data?.data?.[0] || {};
      const doData = doResponse.data?.data?.[0] || {};

      const appDetails = {
        appid: appId || null,
        ApplicationNo: appData.ApplicationNo || "N/A",
        LaboratoryName: appData.LaboratoryName || "N/A",
        ContactPerson: labHeadData.name || "N/A",
        Address: labHeadData.address || "N/A",
        ExtAddress:
          `${labHeadData.city || "N/A"} ${labHeadData.state || "N/A"} ${labHeadData.pincode || "N/A"}`.trim(),
        ContactMobile: labHeadData.mobile || "N/A",
        ContactEmail: labHeadData.email || "N/A",
        DoName: doData.name || "N/A",
        DoEmail: doData.email || "N/A",
        CommunicationLetterSent: appData.CommunicationLetterSent || 0,
      };

      setAppDetailsMap(prev => ({ ...prev, [appId]: appDetails }));
      // Keep single-value state updated for the first application (used by letter handlers)
      setApplicationData(appDetails);
      return appDetails;
    } catch (err) {
      console.error("Error loading application details:", err);
      return null;
    }
  };

  // Load decision data
  const loadDecisionData = async (appId, orgId) => {
    try {
      const commResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getdecision`,
        {
          params: { appid: appId, orgid: orgId },
        },
      );

      const subject = commResponse.data?.subject || "";
      const body = commResponse.data?.body || "";
      const date = commResponse.data?.date || "";
      // Return the data for immediate use
      return {
        subject,
        body,
        date
      };
    } catch (err) {
      console.error("Error loading decision data:", err);
      return {
        subject: "",
        body: "",
        date: ""
      };
    }
  };

  // Load communication data
  const loadCommunicationData = async (appId, orgId) => {
    try {
      const commResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetCommunication`,
        {
          params: { appid: appId, orgid: orgId },
        },
      );

      const subject = commResponse.data?.subject || "";
      const body = commResponse.data?.body || "";
      const date = commResponse.data?.date || "";
      // Return the data for immediate use
      return {
        subject,
        body,
        date
      };
    } catch (err) {
      console.error("Error loading decision data:", err);
      return {
        subject: "",
        body: "",
        date: ""
      };
    }
  };

  // PT Plan Functions
  const fetchPTPlan = async (application) => {
    if (!application?.AppId) return;
    const currentAppId = application.AppId;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getptplan`,
        {
          params: { appid: currentAppId },
        },
      );
      if (response.data && response.data.file !== "") {
        setPtPlanDataMap(prev => ({ ...prev, [currentAppId]: { file: response.data.file, uploaded: true } }));
        // Also update flat state for backward compat (first app)
        setUploadedPtPlanFile(response.data.file);
        setPtPlanUploaded(true);
      } else {
        setUploadedPtPlanFile(null);
        setPtPlanUploaded(false);
        setPtPlanDataMap(prev => ({ ...prev, [currentAppId]: { file: null, uploaded: false } }));
      }
    } catch (err) {
      console.error("Error fetching PT Plan:", err);
      setPtPlanDataMap(prev => ({ ...prev, [currentAppId]: { file: null, uploaded: false } }));
    }
  };

  // Handle file upload from FileUploadComponent
  const handleFileUploadChange = (fieldName, fileData) => {
    if (fieldName === "ptPlanFile") {
      if (fileData) {
        // Store the selected file data
        setSelectedPtPlanFile(fileData);
      } else {
        setSelectedPtPlanFile(null);
      }
    }
  };

  // Load annual fees per application
  const loadAnnualFees = async (application) => {
    if (!application?.AppId) return;
    const currentAppId = application.AppId;
    const currentOrgId = application.OrgId;
    try {
      const annualFeeResponse = await getAnnualFee(currentAppId);
      const aafeeResponse = await paymentService.checkPaymentStatus(currentOrgId, currentAppId);
      if (annualFeeResponse.data.success && annualFeeResponse.data.data) {
        const annualData = annualFeeResponse.data.data;
        const paymentList = aafeeResponse?.data || [];

        const hasAAFeePaid = paymentList.some(
          (item) => Number(item.PaymentTypeId) === 7
        );
        const shouldShow = !hasAAFeePaid;
        setAnnualFeesMap(prev => ({ ...prev, [currentAppId]: { data: annualData, showButton: shouldShow } }));
        // Keep flat state in sync (for first app / backward compat)
        setAnnualFeesData(annualData);
        setShowAnnualFeesButton(shouldShow);
      } else {
        setAnnualFeesMap(prev => ({ ...prev, [currentAppId]: { data: null, showButton: false } }));
      }
    } catch (err) {
      console.warn("Annual fee API failed for appId", currentAppId, err);
      setAnnualFeesMap(prev => ({ ...prev, [currentAppId]: { data: null, showButton: false } }));
    }
  };

  // Load assessment dates per application
  const loadAssessmentDates = async (application) => {
    if (!application?.AppId || !application?.OrgId) return;
    const currentAppId = application.AppId;
    const currentOrgId = application.OrgId;
    try {
      const assessmentUrl = `${process.env.REACT_APP_API_URL}/assessor/GetAssessmentPlan?appid=${currentAppId}&orgid=${currentOrgId}&Assessmenttype=Main`;
      const assessmentResp = await axios.get(assessmentUrl);
      if (
        assessmentResp.data &&
        assessmentResp.data.isstatus &&
        Array.isArray(assessmentResp.data.Date)
      ) {
        setAssessmentDatesMap(prev => ({ ...prev, [currentAppId]: assessmentResp.data.Date }));
        // Keep flat state in sync (for first app / backward compat)
        setAssessmentDates(assessmentResp.data.Date);
      } else {
        setAssessmentDatesMap(prev => ({ ...prev, [currentAppId]: [] }));
      }
    } catch (err) {
      console.warn("Assessment dates not found for appId", currentAppId, err);
      setAssessmentDatesMap(prev => ({ ...prev, [currentAppId]: [] }));
    }
  };

  // Manual upload function for PT Plan
  const handleManualPTPlanUpload = async (application) => {
    if (!selectedPtPlanFile) {
      toast.warning("Please select a file first");
      return;
    }
    const currentAppId = application?.appid;
    try {
      setPtPlanUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/UploadPtplan?appid=${currentAppId}&file=${selectedPtPlanFile.fileName}`,
      );
      if (response.data && response.data.isstatus) {
        const uploadedFileData = {
          fileName:
            response.data.fileName ||
            selectedPtPlanFile.fileName ||
            selectedPtPlanFile.name,
          fileUrl: response.data.filePath || response.data.fileUrl,
          key: response.data.key || response.data.filePath,
        };

        setUploadedPtPlanFile(uploadedFileData);
        setPtPlanUploaded(true);
        setSelectedPtPlanFile(null);
        setPtPlanModalOpen(false);
        toast.success("PT Plan uploaded successfully");

        // Refresh the file list
        await fetchPTPlan(application);
      } else {
        toast.error(response.data?.message || "Failed to upload PT Plan");
      }
    } catch (err) {
      console.error("Error uploading PT Plan:", err);
      toast.error(err.response?.data?.message || "Failed to upload PT Plan");
    } finally {
      setPtPlanUploading(false);
    }
  };

  const handleOpenPTPlanModal = (application) => {
    setPtPlanModalOpen(true);
  };

  const handleClosePTPlanModal = () => {
    setPtPlanModalOpen(false);
    setSelectedPtPlanFile(null);
  };

  const handleViewPTPlan = async (application) => {
    const ptFile = ptPlanDataMap[application?.AppId]?.file || uploadedPtPlanFile;
    if (!ptFile) {
      setError("No file available to view");
      return;
    }
    try {
      setLoading(true);
      // Use s3Utils to handle file opening with signed URLs
      await s3Utils.handleFileViewWithS3(ptFile, {
        showError: (msg) => setError(msg),
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        expiresIn: 172800, // 48 hours
      });
    } catch (err) {
      setError("Failed to open file");
      console.error("Error opening file:", err);
    } finally {
      setLoading(false);
    }
  };

  const downloadNABLFormat = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_PAGE_URL}/NABL-163.pdf`;
    link.download = "NABL-163.pdf";
    link.click();
  };

  const handleDownloadCertificate = (application) => {
    const currentAppId = application?.AppId;
    const currentOrgId = application?.OrgId;
    if (!currentAppId || !currentOrgId) {
      toast.error("Application ID or Organization ID not found");
      return;
    }
    window.open(
      `/main/viewCertificate?appId=${encryptAppId(currentAppId.toString())}&orgId=${encryptText(currentOrgId.toString())}&action=${encryptText("download")}`,
      "_blank",
    );
  };
  const handleDownloadSymbol = (application) => {
    const currentAppId = application?.AppId;
    const currentOrgId = application?.OrgId;
    if (!currentAppId || !currentOrgId) {
      toast.error("Application ID or Organization ID not found");
      return;
    }
    window.open(
      `/main/downloadsymbol?appId=${encryptAppId(currentAppId.toString())}&orgId=${encryptText(currentOrgId.toString())}&action=${encryptText("download")}`,
      "_blank",
    );
  };

  const handleDownloadILACMark = (application) => {
    const currentAppId = application?.AppId;
    if (!currentAppId) {
      toast.error("Application ID not found");
      return;
    }
    window.open(
      `/main/ilac-mark-download?appId=${encryptAppId(currentAppId.toString())}`,
      "_blank",
    );
  };

  const handleViewILACDecisionLetter = async (application) => {
    const appId = application?.AppId;
    const assessmentTypeId = application?.AssessmentTypeId;
    if (!appId || !assessmentTypeId) {
      toast.error("Application ID or Assessment Type ID not found");
      return;
    }
    try {
      toast.info("Generating decision letter...");
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/ilac/lab-acceptance-letter/${appId}/${assessmentTypeId}`);
      const data = res.data?.data || {};

      const letterData = {
        applicationNo: data.ApplicationNo || "N/A",
        letterDate: data.DecisionDate || "N/A",
        contactPerson: data.ContactPerson || "N/A",
        laboratoryName: data.LabName || "N/A",
        address: data.Address || "N/A",
        extAddress: data.Extaddress || "N/A",
        mobile: data.ContactMobile || "N/A",
        email: data.ContactEmail || "N/A",
        subject: data.Subject || "N/A",
        body: data.body || data.Body || "N/A",
        doName: data.Name || "N/A",
        doEmail: data.doEmail || "N/A",
        showNewAddress: new Date() > new Date("2025-07-18"),
      };

      await generateDecisionLetter(letterData);
      toast.success("Decision letter downloaded");
    } catch (err) {
      console.error("Error generating ILAC decision letter:", err);
      toast.error("Failed to generate decision letter");
    }
  };

  // Handle View Communication Letter
  const handleViewLetter = async (application) => {
    const currentAppId = application?.AppId;
    const currentOrgId = application?.OrgId;

    try {
      toast.info("Downloading communication letter...");

      // Load application details if not already loaded
      let appDetails = appDetailsMap[currentAppId] || applicationData;
      if (!appDetails) {
        appDetails = await loadApplicationDetails(currentAppId);
      }

      if (!appDetails) {
        toast.warning("Application data not loaded. Please try again.");
        return;
      }

      // Load communication data and get it directly (don't rely on state)
      const comminicationData = await loadCommunicationData(
        currentAppId,
        currentOrgId,
      );

      const letterData = {
        applicationNo: appDetails.ApplicationNo || "N/A",
        letterDate: comminicationData.date ? new Date(comminicationData.date).toLocaleDateString("en-GB") : '',
        contactPerson: appDetails.ContactPerson || "N/A",
        laboratoryName: appDetails.LaboratoryName || "N/A",
        address: appDetails.Address || "N/A",
        extAddress: appDetails.ExtAddress || "N/A",
        mobile: appDetails.ContactMobile || "N/A",
        email: appDetails.ContactEmail || "N/A",
        subject: comminicationData.subject || "N/A",
        body: comminicationData.body || "N/A",
        advisoryList: [],
        doName: appDetails.DoName || "N/A",
        doEmail: appDetails.DoEmail || "N/A",
        showAdverseNote: false,
        showNewAddress: new Date() > new Date("2025-07-18"),
      };

      await generateCommunicationLetter(letterData);
      toast.success("Communication letter downloaded successfully");
    } catch (err) {
      console.error("Error generating letter:", err);
      toast.error("Failed to generate communication letter");
    }
  };

  // Handle View Decision Letter
  const handleViewDecisionLetter = async (application) => {
    const currentAppId = application?.AppId;
    const currentOrgId = application?.OrgId;

    try {
      toast.info("Downloading decision letter...");

      // Load application details if not already loaded
      let appDetails = appDetailsMap[currentAppId] || applicationData;
      if (!appDetails) {
        appDetails = await loadApplicationDetails(currentAppId);
      }

      if (!appDetails) {
        toast.warning("Application data not loaded. Please try again.");
        return;
      }

      // Load decision data and get it directly (don't rely on state)
      const decisionData = await loadDecisionData(currentAppId, currentOrgId);

      const letterData = {
        applicationNo: appDetails.ApplicationNo || "N/A",
        letterDate: decisionData.date ? new Date(decisionData.date).toLocaleDateString("en-GB") : '',
        contactPerson: appDetails.ContactPerson || "N/A",
        laboratoryName: appDetails.LaboratoryName || "N/A",
        address: appDetails.Address || "N/A",
        extAddress: appDetails.ExtAddress || "N/A",
        mobile: appDetails.ContactMobile || "N/A",
        email: appDetails.ContactEmail || "N/A",
        subject: decisionData.subject || "N/A",
        body: decisionData.body || "N/A",
        advisoryList: [],
        doName: appDetails.DoName || "N/A",
        doEmail: appDetails.DoEmail || "N/A",
        showAdverseNote: false,
        showNewAddress: new Date() > new Date("2025-07-18"),
      };

      await generateDecisionLetter(letterData);
      toast.success("Decision letter downloaded successfully");
    } catch (err) {
      console.error("Error generating letter:", err);
      toast.error("Failed to generate decision letter");
    }
  };

  const handleLaboratoryUpdateDetails = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      // Encrypt the parameters for secure URL transmission
      const encryptedAppId = encryptAppId(appId.toString());
      const encryptedOrgId = encryptText(orgId.toString());

      console.log(
        "🔐 DashboardPage - Encrypting laboratory update parameters:",
        {
          originalAppId: appId,
          originalOrgId: orgId,
          encryptedAppId: encryptedAppId,
          encryptedOrgId: encryptedOrgId,
        },
      );

      // Navigate to laboratory update details page with encrypted parameters
      const updateUrl = `/main/laboratory-update-details?orgId=${encodeURIComponent(encryptedOrgId)}&appId=${encodeURIComponent(encryptedAppId)}`;

      // Navigate to the page
      navigate(updateUrl);
    } catch (error) {
      console.error("Error encrypting laboratory update parameters:", error);
      toast.error("Failed to encrypt parameters");
      // Fallback to unencrypted if encryption fails
      const fallbackUrl = `/main/laboratory-update-details?orgId=${orgId}&appId=${appId}`;
      navigate(fallbackUrl);
    }
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      // Fetch dashboard data new (all applications) and lab name
      const [dashboardDataNewResponse, labNameResponse] = await Promise.all([
        getDashboardDataNew(orgId),
        getLabName(orgId),
      ]);

      // Set dashboard data new (all applications)
      if (dashboardDataNewResponse.data.success) {
        setDashboardDataNew(dashboardDataNewResponse.data.data || []);
      } else {
        console.warn("Dashboard data new not found:", dashboardDataNewResponse.data.message);
        setDashboardDataNew([]);
      }

      // Set lab data if available
      if (labNameResponse.data.success) {
        setLabData(labNameResponse.data.data);
      } else {
        console.warn("Lab name not found:", labNameResponse.data.message);
        // Don't set error for lab name failure - it's optional data
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to connect to server");
    } finally {
      setLoading(false);
    }
  };

  const handleContinueApplication = (application) => {
    if (!application) {
      toast.error("Application data not found");
      return;
    }
    const orgId = application?.OrgId;
    const appId = application?.AppId;

    if (!orgId || !appId) {
      toast.error("Organization ID or Application ID not found");
      return;
    }

    try {
      // Encrypt the parameters for secure URL transmission
      const encryptedAppId = encryptAppId(appId.toString());
      const encryptedOrgId = encryptText(orgId.toString());

      console.log(
        "🔐 DashboardPage - Encrypting continue application parameters:",
        {
          originalAppId: appId,
          originalOrgId: orgId,
          encryptedAppId: encryptedAppId,
          encryptedOrgId: encryptedOrgId,
        },
      );

      const queryParams = `?orgId=${encodeURIComponent(encryptedOrgId)}&appId=${encodeURIComponent(encryptedAppId)}`;

      if (application?.LabTypeId) {
        const labTypeId = application.LabTypeId;
        if (labTypeId === 1) {
          navigate(`/main/testing/laboratory-details${queryParams}`);
        } else if (labTypeId === 2) {
          navigate(`/main/calibration/laboratory-details${queryParams}`);
        } else if (labTypeId === 3) {
          navigate(`/main/medical/laboratory-details${queryParams}`);
        } else {
          navigate(`/main/application-form${queryParams}`);
        }
      } else {
        navigate(`/main/application-form${queryParams}`);
      }
    } catch (error) {
      console.error("Error encrypting continue application parameters:", error);
      toast.error("Failed to encrypt parameters");
      // Fallback to original navigation without encryption
      if (application?.LabTypeId) {
        const labTypeId = application.LabTypeId;
        if (labTypeId === 1) {
          navigate("/main/testing/laboratory-details");
        } else if (labTypeId === 2) {
          navigate("/main/calibration/laboratory-details");
        } else if (labTypeId === 3) {
          navigate("/main/medical/laboratory-details");
        } else {
          navigate("/main/application-form");
        }
      } else {
        navigate("/main/application-form");
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const getStatusColor = (stage) => {
    if (!stage || stage === "Not Started") return "default";
    if (stage.includes("Rejected") || stage.includes("Withdrawn"))
      return "error";
    if (stage.includes("Completed") || stage.includes("Certificate Issued"))
      return "success";
    if (
      stage.includes("Progress") ||
      stage.includes("Review") ||
      stage.includes("Awaiting")
    )
      return "warning";
    return "info";
  };

  const getLabTypeIcon = (labTypeId) => {
    switch (labTypeId) {
      case 1:
        return "🔬"; // Testing
      case 2:
        return "⚖️"; // Calibration
      case 3:
        return "🏥"; // Medical
      default:
        return "�";
    }
  };
  const handleViewInvoice = (payment) => {

    const rawPath = payment?.paths || payment?.Paths || '';
    const apipath = rawPath.replace(/^~\/?/, '');
    const orgid = localStorage.getItem('orgId'); // Assuming orgId is stored in localStorage after login
    console.log(apipath, orgid)
    window.open(
      `https://nablwpnew.qci.org.in/${apipath}&orgid=${orgid}`,
      "_blank",
      "noopener,noreferrer"
    );


  };

  const getLabTypeName = (labTypeId) => {
    switch (labTypeId) {
      case 1:
        return "Testing Laboratory";
      case 2:
        return "Calibration Laboratory";
      case 3:
        return "Medical Laboratory";
      default:
        return "Laboratory";
    }
  };

  const getAssessmentTypeName = (assessmentTypeId) => {
    switch (assessmentTypeId) {
      case 1:
        return "First Accreditation";
      case 2:
        return "Renewal of Accreditation";
      case 3:
        return "Desktop Surveillance";
      case 4:
        return "Onsite Surveillance";
      case 5:
        return "Scope Extension";
      case 6:
        return "Updation of details";
      case 7:
        return "NABL 201";
      case 8:
        return "Change in Name / Legal Identity";
      case 9:
        return "Acquisition / Take over/purchase / selling, Merger / De-Merger of CAB";
      case 10:
        return "Change in CAB's Premises";
      case 11:
        return "Change/Addition of Proposed personnel to report, review and authorize the results (Signing of test reports)";
      case 12:
        return "Change in CAB's personnel other than Proposed personnel to report, review and authorize the results";
      case 13:
        return "Change in CAB's Equipment not affecting scope of accreditation";
      case 15:
        return "Voluntary Suspension / Withdrawal";
      case 16:
        return "Transition to new standard (ISO/IEC 17025:2017)";
      case 17:
        return "Change in test / calibration method or equipment in respect of accredited scope";
      case 18:
        return "Permission to use NABL Accredited CAB combined ILAC MRA Mark.";

      default:
        return "Assessment";
    }
  };

  // Navigate to additional application based on assessment type
  const handleNavigateToAdditionalApp = (application) => {
    if (!application || !application.AssessmentTypeId || !application.AppId || !application.LabTypeId) {
      toast.warning("Invalid application data");
      return;
    }
    const encryptedOrgId = encryptText(orgId.toString());
    const encryptedAppId = encryptText(application.AppId?.toString() || '');
    const encryptedLabTypeId = encryptText(application.LabTypeId?.toString() || '');

    let navigateUrl = '';
    switch (application.AssessmentTypeId) {
      case 5:
        navigateUrl = `/main/medical/discipline?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}&assessmentTypeId=${encryptText(application.AssessmentTypeId.toString())}`;
        break;
      case 8:
        navigateUrl = `/main/add-on/change-name?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}`;
        break;
      case 9:
        navigateUrl = `/main/add-on/acquisition-merger?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}`;
        break;
      case 10:
        navigateUrl = `/main/add-on/change-incab-permises?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}`;
        break;
      case 11:
        navigateUrl = `/main/medical/lab-staff-additional?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}&assessmentTypeId=${encryptText(application.AssessmentTypeId.toString())}`;
        break;
      case 12:
        navigateUrl = `/main/medical/lab-staff-additional?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}&assessmentTypeId=${encryptText(application.AssessmentTypeId.toString())}`;
        break;
      case 13:
        navigateUrl = `/main/medical/discipline?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}&assessmentTypeId=${encryptText(application.AssessmentTypeId.toString())}`;
        break;
      case 17:
        navigateUrl = `/main/medical/discipline?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}&assessmentTypeId=${encryptText(application.AssessmentTypeId.toString())}`;
        break;
      case 18:
        navigateUrl = `/main/add-on/ilac?orgId=${encryptedOrgId}&appId=${encryptedAppId}&labTypeId=${encryptedLabTypeId}`;
        break;
      default:
        toast.warning('Invalid application type');
        return;
    }

    navigate(navigateUrl);
  };

  // Handle Additional Application Dialog
 const handleApplicationTypeSelect = async () => {

  try {

    if (!selectedApplicationType) {

      toast.warning(
        'Please select an application type'
      );

      return;
    }

    const currentOrgId = getOrgId();

    toast.info('Creating application...');

    const createApplicationResponse =
      await axios.post(
        `${process.env.REACT_APP_API_URL}/change-name-app/application/new`,
        {
          OrgId: currentOrgId,
          AssessmentTypeId: selectedApplicationType,
          LabTypeId: dashboardDataNew[0]?.LabTypeId,
          Standard: dashboardDataNew[0]?.Standard,
          CreatedBy: localStorage.getItem('orgId'),
        }
      );

    if (
      !createApplicationResponse.data.success
    ) {

      toast.error(
        createApplicationResponse.data.message ||
        'Failed to create application'
      );

      return;
    }

    toast.success(
      'Application created successfully'
    );

    // Reset states
    setOpenAdditionalAppDialog(false);
    setOpenPasswordDialog(false);

    setPassword('');
    setUsername('');
    setSelectedApplicationType('');

    await fetchDashboardData();

  } catch (error) {

    console.error(
      'Error creating application:',
      error
    );

    toast.error(
      error.response?.data?.message ||
      'Failed to create application'
    );
  }
};

  // Fetch assessment types from API
  const fetchAssessmentTypes = async () => {
    try {
      setAssessmentTypesLoading(true);
      const response = await getAssessmentTypes();

      if (response.data.success) {
        setAssessmentTypes(response.data.data);
      } else {
        console.error('Failed to fetch assessment types');
        toast.error('Failed to load application types');
      }
    } catch (error) {
      console.error('Error fetching assessment types:', error);
      toast.error('Error loading application types');
    } finally {
      setAssessmentTypesLoading(false);
    }
  };

  // Open additional app dialog and fetch assessment types
  const handleOpenAdditionalAppDialog = () => {
    setOpenPasswordDialog(true);
  };

  // Handle Password Verification
  const handlePasswordVerification = async () => {

    try {

      if (!password) {
        toast.warning('Please enter password');
        return;
      }

      setCreatingApplication(true);
      // Verify current portal password
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: localStorage.getItem('orgId'),
          password: password,
        }
      );

      if (!passwordResponse.data.success) {

        toast.error('Invalid password');
        return;
      }

      // First API validation
      const validationResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/Validityforthis`,
        {
          username:localStorage.getItem('username'),
          password,
          appId: dashboardDataNew[0]?.AppId
        }
      );
      // If validation failed
      if (validationResponse.data.success == true) {
        fetchAssessmentTypes()
        setOpenAdditionalAppDialog(true)
         setOpenPasswordDialog(false);
       
      } else {
         toast.error(
          validationResponse.data.message ||
          'Invalid credentials'
        );

        return;
      }

      
    } catch (err) {
      console.error('Error verifying password:', err);
      toast.error(err.response?.data?.message || 'Error verifying password');

      // Open application type popup
      setOpenPasswordDialog(false);
      // Load dropdown data
      if (assessmentTypes.length === 0) {
        fetchAssessmentTypes();
      }

    } finally {

      // setOpenAdditionalAppDialog(false);
    }
  };

  // Handle dialog close
  const handleCloseAdditionalAppDialog = () => {
    setOpenAdditionalAppDialog(false);
    setSelectedApplicationType('');
  };

  const handleClosePasswordDialog = () => {
    setOpenPasswordDialog(false);
    setPassword('');
  };

  if (loading) {
    return (
      <LoaderWrapper
        loading={true}
        type="fullscreen"
        message="Loading Dashboard..."
      />
    );
  }

  if (error) {
    return (
      <Box sx={{ mt: 8, minHeight: "100vh", bgcolor: "white", py: 4 }}>
        <Container maxWidth="lg">
          <Alert
            severity="error"
            sx={{
              mb: 2,
              border: "1px solid #f44336",
              bgcolor: "#ffebee",
            }}
          >
            {error}
          </Alert>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="contained"
              onClick={fetchDashboardData}
              sx={{
                mr: 2,
                bgcolor: "#333",
                "&:hover": { bgcolor: "#555" },
              }}
            >
              Retry
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/main/application-form")}
              sx={{
                borderColor: "#666",
                color: "#666",
                "&:hover": { borderColor: "#333", color: "#333" },
              }}
            >
              Continue to Application Form
            </Button>
          </Box>
        </Container>
      </Box>
    );
  }

  if (!dashboardDataNew || dashboardDataNew.length === 0) {
    return (
      <Box sx={{ mt: 8, minHeight: "100vh", bgcolor: "white", py: 4 }}>
        <Container maxWidth="lg">
          <Alert
            severity="info"
            sx={{
              border: "1px solid #2196f3",
              bgcolor: "#e3f2fd",
            }}
          >
            No application data found. Please start a new application.
          </Alert>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="contained"
              onClick={() => navigate("/main/application-form")}
              sx={{
                bgcolor: "#333",
                "&:hover": { bgcolor: "#555" },
              }}
            >
              Start Application
            </Button>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mt: 8,
        minHeight: "100vh",
        bgcolor: "white",
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        {/* Application Information Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Application Details Card */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={1}
              sx={{ height: "100%", border: "1px solid #e0e0e0" }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 3,
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <BusinessIcon sx={{ color: "#666", mr: 2, fontSize: 28 }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, color: "#333" }}
                    >
                      Application Details
                    </Typography>
                  </Box>
                  {/* SCF Dashboard Button - show if btn_scf is 'true' */}
                  {dashboardDataNew[0].btn_scf === "true" && (
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        const targetUrl = `https://nablwpnew.qci.org.in/SCF_Integration/Transfer.aspx?user=Lab&orgid=${dashboardDataNew[0].OrgId}`;
                        window.location.href = targetUrl;
                      }}
                      sx={{ ml: 2 }}
                    >
                      SCF Dashboard
                    </Button>
                  )}
                  <>
                  <Button
                    variant="contained"
                    onClick={() => {
                      const uname = localStorage.getItem('username') || '';
                      navigate(`/main/outstanding-ledger?username=${encryptText(uname)}`);
                    }}
                    sx={{ ml: 2, bgcolor: '#E34124', '&:hover': { bgcolor: '#c73518' } }}
                  >
                    Accounts Section
                  </Button>
                  </>
                </Box>

                <Grid container spacing={2}>
                  {/* Lab Name Section */}
                  {labData && (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          mb: 3,
                          p: 2,
                          bgcolor: "#e3f2fd",
                          borderRadius: 2,
                          border: "1px solid #90caf9",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "#1565c0", mb: 0.5, fontWeight: 500 }}
                        >
                          Laboratory Name:
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, color: "#0d47a1" }}
                        >
                          {labData.labName || "N/A"}
                        </Typography>
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={6}>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", mb: 0.5 }}
                      >
                        Lab Type:
                      </Typography>
                      <Chip
                        label={getLabTypeName(dashboardDataNew[0].LabTypeId)}
                        size="small"
                        sx={{
                          bgcolor: "#f5f5f5",
                          color: "#666",
                          border: "1px solid #e0e0e0",
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", mb: 0.5 }}
                      >
                        Standard:
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, color: "#333" }}
                      >
                        {(dashboardDataNew[0].LabTypeId === 1 || dashboardDataNew[0].LabTypeId === 2) ? `ISO/IEC 17025: ${dashboardDataNew[0].Standard}` :
                          dashboardDataNew[0].LabTypeId === 3 ? `ISO 15189: ${dashboardDataNew[0].Standard}` : "N/A"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", mb: 0.5 }}
                      >
                        Application Type:
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, color: "#333" }}
                      >
                        {getAssessmentTypeName(dashboardDataNew[0].AssessmentTypeId)}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Current Stage Card */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={1}
              sx={{ height: "100%", border: "1px solid #e0e0e0" }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <AssessmentIcon
                      sx={{ color: "#666", mr: 2, fontSize: 28 }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, color: "#333" }}
                    >
                      Current Status
                    </Typography>
                  </Box>
                  {showAdditionalAppButton && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleOpenAdditionalAppDialog}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      boxShadow: 2,
                      "&:hover": {
                        boxShadow: 4,
                      },
                    }}
                  >
                    Create Additional Application
                  </Button>
                  )}

                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                        Application Description:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          bgcolor: "#98ffcfff",
                          p: 2,
                          borderRadius: 1,
                          border: "1px solid #26a27dff",
                          color: "#333",
                          fontWeight: 500,
                        }}
                      >
                        {dashboardDataNew[0].stageDescription}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
                        Quick Actions:
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={<Person2Outlined />}
                        onClick={handleOpenContactDialog}
                        size="small"
                        color="success"
                        sx={{
                          borderColor: "secondary.main",
                          mx: 2,
                          "&:hover": {
                            borderColor: "secondary.dark",
                            backgroundColor: "secondary.50",
                          },
                        }}
                      >
                        Contact Persons
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<Person2Outlined />}
                        onClick={handleOpenOfficerDialog}
                        size="small"
                        color="success"
                        sx={{
                          borderColor: "secondary.main",
                          "&:hover": {
                            borderColor: "secondary.dark",
                            backgroundColor: "secondary.50",
                          },
                        }}
                      >
                        Dealing Officer
                      </Button>
                      <br />
                      <br />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Application Timeline Table */}
        <Paper
          elevation={3}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #e3f2fd",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderBottom: "3px solid #5568d3",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#ffffff",
                letterSpacing: "0.5px",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              📋 Application Timeline
            </Typography>
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                >
                  <TableCell
                    sx={{
                      color: "#ffffff",
                      fontWeight: 700,
                      borderBottom: "2px solid #5568d3",
                      fontSize: "0.95rem",
                      py: 2,
                    }}
                    align="center"
                  >
                    Application ID
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#ffffff",
                      fontWeight: 700,
                      borderBottom: "2px solid #5568d3",
                      fontSize: "0.95rem",
                      py: 2,
                    }}
                  >
                    Application Type / Description
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#ffffff",
                      fontWeight: 700,
                      borderBottom: "2px solid #5568d3",
                      fontSize: "0.95rem",
                      py: 2,
                    }}
                  >
                    Created Date
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#ffffff",
                      fontWeight: 700,
                      borderBottom: "2px solid #5568d3",
                      fontSize: "0.95rem",
                      py: 2,
                    }}
                  >
                    Submitted Date
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#ffffff",
                      fontWeight: 700,
                      borderBottom: "2px solid #5568d3",
                      fontSize: "0.95rem",
                      py: 2,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dashboardDataNew && dashboardDataNew.length > 0 ? (
                  dashboardDataNew.map((application, index) => {
                    const isMainApplication = application.AssessmentTypeId === 1;
                    const isAdditionalApplication = [5, 8, 9, 10, 11, 12, 13, 17, 18].includes(application.AssessmentTypeId);

                    return (
                      <TableRow
                        key={application.AppId || index}
                        hover
                        sx={{
                          "&:hover": {
                            bgcolor: "#f5f9ff",
                            transform: "scale(1.001)",
                            transition: "all 0.2s ease",
                          },
                          borderLeft: "4px solid transparent",
                          "&:hover": {
                            borderLeft: "4px solid #667eea",
                            bgcolor: "#f5f9ff",
                          },
                        }}
                      >
                        <TableCell
                          align="center"
                          sx={{ borderBottom: "1px solid #f0f0f0" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Chip
                              label={application.ApplicationNo || "N/A"}
                              sx={{
                                bgcolor: isMainApplication ? "#667eea" : "#f59e0b",
                                color: "#ffffff",
                                fontWeight: 600,
                                fontSize: "0.85rem",
                                px: 1,
                              }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "1px solid #f0f0f0" }}>
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500, color: "#333" }}
                            >
                              {getAssessmentTypeName(
                                application.AssessmentTypeId,
                              )}
                            </Typography>

                            <Typography
                              variant="caption"
                              sx={{ color: "#666", mt: 0.5 }}
                            >
                              {application.stageDescription
                                ? `(${application.stageDescription})`
                                : ""}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "1px solid #f0f0f0" }}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <CalendarIcon
                              sx={{ color: "#666", mr: 1, fontSize: 16 }}
                            />
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formatDate(application.InsertDate)}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell sx={{ borderBottom: "1px solid #f0f0f0" }}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <CalendarIcon
                              sx={{ color: "#666", mr: 1, fontSize: 16 }}
                            />
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formatDate(application.SubmitDate)}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "1px solid #f0f0f0" }}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              flexWrap: "wrap",
                              alignItems: "center",
                            }}
                          >
                            {isAdditionalApplication && (
                              <>
                                {(application.Stage === "" ||
                                  !application.Stage) && (
                                    <Button
                                      variant="contained"
                                      startIcon={<EditIcon />}
                                      onClick={() =>
                                        handleNavigateToAdditionalApp(application)
                                      }
                                      size="small"
                                      sx={{
                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        color: "#ffffff",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                                        "&:hover": {
                                          background: "linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)",
                                          boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                                        },
                                      }}
                                    >
                                      View / Edit Application
                                    </Button>
                                  )}
                                {(application.Stage === "15a" &&
                                  <Button
                                    variant="contained"
                                    startIcon={<EditIcon />}
                                    onClick={() =>
                                      handleNavigateToAdditionalApp(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)",
                                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                                      },
                                    }}
                                  >
                                    Edit Application
                                  </Button>
                                )}
                              </>
                            )}
                            <>
                              {application.Stage && (
                                <Button
                                  variant="contained"
                                  startIcon={<DescriptionIcon />}
                                  onClick={() =>
                                    handlePreviewReportNewTab(application)
                                  }
                                  disabled={loading || pdfLoading}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(245, 87, 108, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #e082ea 0%, #e4465b 100%)",
                                      boxShadow: "0 4px 12px rgba(245, 87, 108, 0.4)",
                                    },
                                  }}
                                >
                                  Preview Report
                                </Button>
                              )}
                              {application.Stage && (
                                <Button
                                  variant="contained"
                                  startIcon={<DescriptionIcon />}
                                  onClick={() => {
                                    handleForm131NewTab(application)
                                    setDialogAppId(application.AppId);
                                    setDialogOrgId(application.OrgId);
                                    setDialogStage(application.Stage);
                                    setDialogLabTypeId(String(application.LabTypeId));
                                    setForm131DialogOpen(true);
                                  }}
                                  disabled={loading || pdfLoading}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(245, 87, 108, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #e082ea 0%, #e4465b 100%)",
                                      boxShadow: "0 4px 12px rgba(245, 87, 108, 0.4)",
                                    },
                                  }}
                                >
                                  Form131 Report
                                </Button>
                              )}
                              {(application.Stage === "20" ||
                                application.Stage === "21" ||
                                application.Stage === "6a" ||
                                application.Stage === "6b" ||
                                application.Stage === "6c" ||
                                application.Stage === "6d" ||
                                application.Stage === "6e" ||
                                application.Stage === "6f" ||
                                application.Stage === "7" ||
                                application.Stage === "7a" ||
                                application.Stage === "7b" ||
                                application.Stage === "7c" ||
                                application.Stage === "7d" ||
                                application.Stage === "7e" ||
                                application.Stage === "7f" ||
                                application.Stage === "7g" ||
                                application.Stage === "7h" ||
                                application.Stage === "11b" ||
                                application.Stage === "12" ||
                                application.Stage === "12a" ||
                                application.Stage === "12b" ||
                                application.Stage === "13" ||
                                application.Stage === "13a" ||
                                application.Stage === "13b" ||
                                application.Stage === "13c" ||
                                application.Stage === "13d" ||
                                application.Stage === "13e" ||
                                application.Stage === "11f" ||
                                application.Stage === "11g" ||
                                application.Stage === "13") && (
                                  <Button
                                    variant="contained"
                                    startIcon={<DescriptionIcon />}
                                    onClick={() => {
                                      setDialogAppId(application.AppId);
                                      setDialogOrgId(application.OrgId);
                                      setDialogStage(application.Stage);
                                      setDialogLabTypeId(String(application.LabTypeId));
                                      setAssessorDialogOpen(true);
                                    }}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(79, 172, 254, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #3e9bed 0%, #00e1ed 100%)",
                                        boxShadow: "0 4px 12px rgba(79, 172, 254, 0.4)",
                                      },
                                    }}
                                  >
                                    View Assessment Details
                                  </Button>
                                )}
                              {application.Stage && (
                                <Button
                                  variant="contained"
                                  startIcon={<ReportIcon />}
                                  onClick={() => {
                                    setDialogAppId(application.AppId);
                                    setDialogOrgId(application.OrgId);
                                    setDialogStage(application.Stage);
                                    setDialogLabTypeId(String(application.LabTypeId));
                                    setReportsDialogOpen(true);
                                  }}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                                    color: "#333",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(168, 237, 234, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #97dcd9 0%, #edc5d2 100%)",
                                      boxShadow: "0 4px 12px rgba(168, 237, 234, 0.4)",
                                    },
                                  }}
                                >
                                  View Reports
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                startIcon={<FeesIcon />}
                                onClick={() => handleViewPayments(application)}
                                size="small"
                                sx={{
                                  background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                                  color: "#333",
                                  fontWeight: 600,
                                  textTransform: "none",
                                  boxShadow: "0 2px 8px rgba(168, 237, 234, 0.3)",
                                  "&:hover": {
                                    background: "linear-gradient(135deg, #97dcd9 0%, #edc5d2 100%)",
                                    boxShadow: "0 4px 12px rgba(168, 237, 234, 0.4)",
                                  },
                                }}
                              >
                                View Payment Details
                              </Button>
                              <Button
                                variant="contained"
                                startIcon={<DescriptionIcon />}
                                onClick={() =>
                                  handleAdditionalDocument(application)
                                }
                                disabled={loading}
                                size="small"
                                sx={{
                                  background: "linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)",
                                  color: "#ffffff",
                                  fontWeight: 600,
                                  textTransform: "none",
                                  boxShadow: "0 2px 8px rgba(213, 126, 235, 0.3)",
                                  "&:hover": {
                                    background: "linear-gradient(135deg, #ebba7f 0%, #c46dda 100%)",
                                    boxShadow: "0 4px 12px rgba(213, 126, 235, 0.4)",
                                  },
                                }}
                              >
                                Additional Documents
                              </Button>

                              {(application.Stage === "18a" ||
                                hasValidUnfreezeRecord(application)) && (
                                  <Button
                                    variant="contained"
                                    startIcon={<EditIcon />}
                                    onClick={() =>
                                      handleEditApplication(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)",
                                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                                      },
                                    }}
                                  >
                                    Edit Application
                                  </Button>
                                )}
                              {application.Stage === "19" && (
                                <Button
                                  variant="contained"
                                  startIcon={<CalendarIcon />}
                                  onClick={() =>
                                    handleChooseAssessmentDate(application)
                                  }
                                  disabled={loading}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(67, 233, 123, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #32d86a 0%, #27e8c6 100%)",
                                      boxShadow: "0 4px 12px rgba(67, 233, 123, 0.4)",
                                    },
                                  }}
                                >
                                  Choose Assessment Date
                                </Button>
                              )}
                              {application.Stage === "19e" && (
                                <Button
                                  variant="contained"
                                  startIcon={<ViewIcon />}
                                  onClick={() =>
                                    handleAssessmentDetails(application)
                                  }
                                  disabled={loading}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(67, 233, 123, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #32d86a 0%, #27e8c6 100%)",
                                      boxShadow: "0 4px 12px rgba(67, 233, 123, 0.4)",
                                    },
                                  }}
                                >
                                  Assessment Details
                                </Button>
                              )}
                             
                              {/* Pay Assessment Fees Button - Show conditionally - Only for selected app */}
                              {assessmentFeesMap[application.AppId]?.showPayAssessmentFeesButton && (
                                <Button
                                  variant="contained"
                                  startIcon={<PaymentIcon />}
                                  onClick={() =>
                                    handlePayAssessmentFees(application)
                                  }
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(250, 112, 154, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #e95f89 0%, #edd02f 100%)",
                                      boxShadow: "0 4px 12px rgba(250, 112, 154, 0.4)",
                                    },
                                  }}
                                >
                                  Pay Assessment Fees
                                </Button>
                              )}

                              {/* Annual Accreditation Fees Button - Show only if annual fees data exists and AAFEEDone is 0 - Only for selected app */}
                              {annualFeesMap[application.AppId]?.showButton && (
                                <Button
                                  variant="contained"
                                  startIcon={<PaymentIcon />}
                                  onClick={() =>
                                    handlePayAnnualFees(application)
                                  }
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(250, 112, 154, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #e95f89 0%, #edd02f 100%)",
                                      boxShadow: "0 4px 12px rgba(250, 112, 154, 0.4)",
                                    },
                                  }}
                                >
                                  Pay Annual Accreditation Fees
                                </Button>
                              )}
                              {application.Stage === "19f" &&
                                hasValidUnfreezeRecord(application) && (
                                  <Button
                                    variant="contained"
                                    startIcon={<EditIcon />}
                                    onClick={() =>
                                      handleEditApplication(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(255, 107, 107, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #ee5a5a 0%, #dd495e 100%)",
                                        boxShadow: "0 4px 12px rgba(255, 107, 107, 0.4)",
                                      },
                                    }}
                                  >
                                    CAB Rejected - Edit Application
                                  </Button>
                                )}
                              {(application.Stage === "20" ||
                                application.Stage === "21") && (
                                  <Button
                                    variant="contained"
                                    startIcon={<UpdateIcon />}
                                    onClick={() =>
                                      handleLaboratoryUpdateDetails(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)",
                                      color: "#333",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(253, 219, 146, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #ecca81 0%, #c0ecee 100%)",
                                        boxShadow: "0 4px 12px rgba(253, 219, 146, 0.4)",
                                      },
                                    }}
                                  >
                                    Assessment Details
                                  </Button>
                                )}
                              {assessmentDatesMap[application.AppId] &&
                                assessmentDatesMap[application.AppId].length > 0 &&
                                application.Stage === "19a" && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                      const isCurrentlyExpanded = expandDates && expandDatesAppId === application.AppId;
                                      setExpandDates(!isCurrentlyExpanded);
                                      setExpandDatesAppId(isCurrentlyExpanded ? null : application.AppId);
                                    }}
                                    endIcon={
                                      <ExpandMoreIcon
                                        sx={{
                                          transform: (expandDates && expandDatesAppId === application.AppId)
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.3s",
                                        }}
                                      />
                                    }
                                    sx={{
                                      borderColor: "#1976d2",
                                      color: "#1976d2",
                                      "&:hover": {
                                        borderColor: "#1565c0",
                                        bgcolor: "#e3f2fd",
                                      },
                                    }}
                                  >
                                    {(expandDates && expandDatesAppId === application.AppId) ? "Hide" : "Show"} Tentative
                                    Assessment Dates ({(assessmentDatesMap[application.AppId] || []).length}
                                    )
                                  </Button>
                                )}
                              {(application.Stage === "7g" ||
                                application.Stage === "12" ||
                                application.Stage === "12b") && (
                                  <Button
                                    variant="contained"
                                    startIcon={<ReplyIcon />}
                                    onClick={() =>
                                      handleAdvisoryDetails(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      background: "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
                                      color: "#333",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(251, 194, 235, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #eab1da 0%, #95b0dd 100%)",
                                        boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
                                      },
                                    }}
                                  >
                                    Advisory
                                  </Button>
                                )}
                              {appDetailsMap[application.AppId]?.CommunicationLetterSent === 1 && (
                                <Button
                                  variant="contained"
                                  startIcon={<ViewIcon />}
                                  onClick={() =>
                                    handleViewLetter(application)
                                  }
                                  disabled={loading}
                                  size="small"
                                  sx={{
                                    mr: 1,
                                    background: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(48, 207, 208, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #1fbebf 0%, #220756 100%)",
                                      boxShadow: "0 4px 12px rgba(48, 207, 208, 0.4)",
                                    },
                                  }}
                                >
                                  View Communication Letter
                                </Button>
                              )}
                              {(
                                application.Stage === "7" ||
                                application.Stage === "7a" ||
                                application.Stage === "7b" ||
                                application.Stage === "7c" ||
                                application.Stage === "7d") &&
                                assessmentFeesMap[application.AppId]?.showPayAssessmentFeesButton === false &&
                                !annualFeesMap[application.AppId]?.showButton &&
                                (
                                  <>
                                    {ptPlanDataMap[application.AppId]?.uploaded ? (
                                      <Button
                                        variant="contained"
                                        startIcon={<ViewIcon />}
                                        onClick={() =>
                                          handleViewPTPlan(application)
                                        }
                                        size="small"
                                        sx={{
                                          mr: 1,
                                          background: "linear-gradient(135deg, #2af598 0%, #009efd 100%)",
                                          color: "#ffffff",
                                          fontWeight: 600,
                                          textTransform: "none",
                                          boxShadow: "0 2px 8px rgba(42, 245, 152, 0.3)",
                                          "&:hover": {
                                            background: "linear-gradient(135deg, #19e487 0%, #008dec 100%)",
                                            boxShadow: "0 4px 12px rgba(42, 245, 152, 0.4)",
                                          },
                                        }}
                                      >
                                        View PT Plan
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        startIcon={<CloudUploadIcon />}
                                        onClick={() =>
                                          handleOpenPTPlanModal(application)
                                        }
                                        size="small"
                                        sx={{
                                          mr: 1,
                                          background: "linear-gradient(135deg, #fa8bff 0%, #2bd2ff 100%)",
                                          color: "#ffffff",
                                          fontWeight: 600,
                                          textTransform: "none",
                                          boxShadow: "0 2px 8px rgba(250, 139, 255, 0.3)",
                                          "&:hover": {
                                            background: "linear-gradient(135deg, #e97aee 0%, #1ac1ee 100%)",
                                            boxShadow: "0 4px 12px rgba(250, 139, 255, 0.4)",
                                          },
                                        }}
                                      >
                                        Upload PT Plan
                                      </Button>
                                    )}
                                  </>
                                )}

                              {application.Stage === "15d" && [11, 12, 18].includes(application.AssessmentTypeId) && (
                                <>
                              {application.AssessmentTypeId === 18 && (
                                <>
                                <Button
                                  variant="contained"
                                  startIcon={<CalendarIcon />}
                                  onClick={() =>
                                    handleILacReport(application)
                                  }
                                  disabled={loading}
                                  size="small"
                                  sx={{
                                    background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
                                    color: "#ffffff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(67, 233, 123, 0.3)",
                                    "&:hover": {
                                      background: "linear-gradient(135deg, #32d86a 0%, #27e8c6 100%)",
                                      boxShadow: "0 4px 12px rgba(67, 233, 123, 0.4)",
                                    },
                                  }}
                                >
                                  Agreement for use of NABL Accredited CAB Combined ILAC MRA Mark
                                </Button>
                                 <Button
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() =>
                                      handleDownloadILACMark(application)
                                    }
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      background: "linear-gradient(135deg, #00024c 0%, #1a1aff 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(0, 2, 76, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #00013a 0%, #0000cc 100%)",
                                        boxShadow: "0 4px 12px rgba(0, 2, 76, 0.4)",
                                      },
                                    }}
                                  >
                                    Download NABL Accredited CAB Combined ILAC MRA Mark
                                  </Button>
                                  </>
                                  )}
                                  <Button
                                    variant="contained"
                                    startIcon={<ViewIcon />}
                                    onClick={() =>
                                      handleViewILACDecisionLetter(application)
                                    }
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      background: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
                                      color: "#333",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(161, 196, 253, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #90b3ec 0%, #b1d8ea 100%)",
                                        boxShadow: "0 4px 12px rgba(161, 196, 253, 0.4)",
                                      },
                                    }}
                                  >
                                    View Decision Letter
                                  </Button>
                                  </>
                              )}
                              {(application.Stage === "7d" &&
                                ptPlanDataMap[application.AppId]?.uploaded &&
                                assessmentFeesMap[application.AppId]?.showPayAssessmentFeesButton === false &&
                                !annualFeesMap[application.AppId]?.showButton) ? (
                                <>
                                  <Button
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() =>
                                      handleDownloadCertificate(application)
                                    }
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      background: "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(246, 211, 101, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #e5c254 0%, #ec8f74 100%)",
                                        boxShadow: "0 4px 12px rgba(246, 211, 101, 0.4)",
                                      },
                                    }}
                                  >
                                    Download Certificate
                                  </Button>
                                  <Button
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() =>
                                      handleDownloadSymbol(application)
                                    }
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      background: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
                                      color: "#ffffff",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(255, 154, 158, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #ee898d 0%, #edbede 100%)",
                                        boxShadow: "0 4px 12px rgba(255, 154, 158, 0.4)",
                                      },
                                    }}
                                  >
                                    Download NABL Symbol
                                  </Button>
                                 
                                  <Button
                                    variant="contained"
                                    startIcon={<ViewIcon />}
                                    onClick={() =>
                                      handleViewDecisionLetter(application)
                                    }
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                      mr: 1,
                                      background: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
                                      color: "#333",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      boxShadow: "0 2px 8px rgba(161, 196, 253, 0.3)",
                                      "&:hover": {
                                        background: "linear-gradient(135deg, #90b3ec 0%, #b1d8ea 100%)",
                                        boxShadow: "0 4px 12px rgba(161, 196, 253, 0.4)",
                                      },
                                    }}
                                  >
                                    View Decision Letter
                                  </Button>
                                </>
                              ) : (
                                application.Stage === "7d" && (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {annualFeesMap[application.AppId]?.showButton
                                      ? "Please complete the annual fee payment to access the certificate."
                                      : assessmentFeesMap[application.AppId]?.showPayAssessmentFeesButton === true
                                        ? "Please complete the assessment fee payment to access the certificate."
                                        : !ptPlanDataMap[application.AppId]?.uploaded
                                          ? "Please upload PT Plan to access certificate."
                                          : ""}
                                  </Typography>
                                )
                              )}
                              <TerminateApplicationDialog appId={application.AppId} stage={application.Stage} />
                            </>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No applications found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}

                {/* Assessment Dates Expandable Rows */}
                {expandDates &&
                  expandDatesAppId &&
                  assessmentDatesMap[expandDatesAppId] &&
                  assessmentDatesMap[expandDatesAppId].length > 0 && (
                    <>
                      <TableRow sx={{ bgcolor: "#f5f9ff" }}>
                        <TableCell
                          colSpan={5}
                          sx={{
                            borderBottom: "2px solid #1976d2",
                            py: 1.5,
                            px: 3,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: 700, color: "#1976d2" }}
                            >
                              📅 Tentative Assessment Dates
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ bgcolor: "#e3f2fd" }}>
                        <TableCell
                          align="center"
                          sx={{
                            borderBottom: "2px solid #1976d2",
                            py: 1.5,
                            fontWeight: 700,
                            color: "#1976d2",
                          }}
                        >
                          Period
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "2px solid #1976d2",
                            py: 1.5,
                            fontWeight: 700,
                            color: "#1976d2",
                          }}
                        >
                          From Date
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          sx={{
                            borderBottom: "2px solid #1976d2",
                            py: 1.5,
                            fontWeight: 700,
                            color: "#1976d2",
                          }}
                        >
                          To Date
                        </TableCell>
                      </TableRow>
                      {(assessmentDatesMap[expandDatesAppId] || []).map((date, index) => (
                        <TableRow
                          key={date.Id || index}
                          sx={{
                            bgcolor: "#f5f9ff",
                            "&:hover": { bgcolor: "#e3f2fd" },
                          }}
                        >
                          <TableCell
                            align="center"
                            sx={{ borderBottom: "1px solid #e0e0e0", py: 2 }}
                          >
                            <Chip
                              label={`Period ${index + 1}`}
                              sx={{
                                bgcolor: "#667eea",
                                color: "#ffffff",
                                fontWeight: 600,
                                fontSize: "0.85rem",
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell
                            sx={{ borderBottom: "1px solid #e0e0e0", py: 2 }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <CalendarIcon
                                sx={{ color: "#666", fontSize: 16 }}
                              />
                              <Typography
                                variant="body2"
                                sx={{ color: "#333", fontWeight: 500 }}
                              >
                                {date.Datefrom || "-"}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            colSpan={3}
                            sx={{ borderBottom: "1px solid #e0e0e0", py: 2 }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <CalendarIcon
                                sx={{ color: "#666", fontSize: 16 }}
                              />
                              <Typography
                                variant="body2"
                                sx={{ color: "#333", fontWeight: 500 }}
                              >
                                {date.Dateto || "-"}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        {/* Assessor Details Dialog */}
        <Dialog
          open={assessorDialogOpen}
          onClose={() => setAssessorDialogOpen(false)}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '90vh'
            }
          }}
        >
          <DialogTitle sx={{
            bgcolor: '#1976d2',
            color: 'white',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            View Assessment Details
          </DialogTitle>
          <DialogContent sx={{ p: 0, mt: 2 }}>
            {dialogAppId && dialogOrgId ? (
              <AssessorDetailsView
                appId={encryptAppId(dialogAppId.toString())}
                orgId={encryptText(dialogOrgId.toString())}
                type="LAB"
                stage={dialogStage}
                assessorsData={assessorsData}
              />
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography>Loading...</Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setAssessorDialogOpen(false)} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Reports Details Dialog */}
        <Dialog
          open={reportsDialogOpen}
          onClose={() => setReportsDialogOpen(false)}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '90vh'
            }
          }}
        >
          <DialogTitle sx={{
            bgcolor: '#9c27b0',
            color: 'white',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <ReportIcon />
            Reports Details
          </DialogTitle>
          <DialogContent sx={{ p: 0, mt: 2 }}>
            {dialogAppId && dialogOrgId ? (
              <ReportsDetails appId={dialogAppId} orgId={dialogOrgId} type="LAB" labTypeId={dialogLabTypeId} />
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography>Loading...</Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setReportsDialogOpen(false)} variant="contained" color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Payments Details Dialog */}
        <Dialog
          open={paymentsDialogOpen}
          onClose={() => setPaymentsDialogOpen(false)}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '90vh'
            }
          }}
        >
          <DialogTitle sx={{
            bgcolor: '#9c27b0',
            color: 'white',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <ReportIcon />
            Payments Details
          </DialogTitle>
          <DialogContent sx={{ p: 0, mt: 2 }}>
            <>
              {paymentDetails &&
                Array.isArray(paymentDetails) &&
                paymentDetails.length > 0 && (
                  <Paper
                    elevation={1}
                    sx={{
                      mt: 4,
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        py: 2,
                        px: 2,
                        background:
                          "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        color: "white",
                        borderRadius: 1,
                        mb: 0,
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PaymentIcon />
                        Payment Details ({paymentDetails.length}{" "}
                        {paymentDetails.length === 1 ? "Payment" : "Payments"})
                      </Typography>
                    </Box>

                    <Box sx={{ p: 3 }}>
                      {paymentDetails.map((payment, index) => (
                        <Box
                          key={payment.TID || payment.order_id || index}
                          sx={{ mb: index < paymentDetails.length - 1 ? 4 : 0 }}
                        >
                          {/* Payment Header */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 2,
                              pb: 1,
                              borderBottom: "2px solid #e5e7eb",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: 600, color: "#1e293b" }}
                            >
                              Payment #{index + 1}
                            </Typography>
                            <Chip
                              label={payment.order_status || "Pending"}
                              size="medium"
                              icon={
                                payment.order_status?.toLowerCase() === "success" ? (
                                  <CheckCircleIcon />
                                ) : payment.order_status?.toLowerCase() ===
                                  "failed" ? (
                                  <CancelIcon />
                                ) : (
                                  <AccessTimeIcon />
                                )
                              }
                              sx={{
                                bgcolor:
                                  payment.order_status?.toLowerCase() === "success"
                                    ? "#dcfce7"
                                    : payment.order_status?.toLowerCase() === "failed"
                                      ? "#fee2e2"
                                      : "#fef3c7",
                                color:
                                  payment.order_status?.toLowerCase() === "success"
                                    ? "#166534"
                                    : payment.order_status?.toLowerCase() === "failed"
                                      ? "#991b1b"
                                      : "#92400e",
                                fontWeight: "bold",
                                "& .MuiChip-icon": {
                                  color:
                                    payment.order_status?.toLowerCase() === "success"
                                      ? "#166534"
                                      : payment.order_status?.toLowerCase() ===
                                        "failed"
                                        ? "#991b1b"
                                        : "#92400e",
                                },
                              }}
                            />
                          </Box>

                          <Grid container spacing={3}>
                            {/* Transaction ID (TID) */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Card
                                variant="outlined"
                                sx={{ height: "100%", bgcolor: "#f8fafc" }}
                              >
                                <CardContent>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Transaction ID
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 600, color: "#1e293b", mt: 1 }}
                                  >
                                    {payment.TID || "N/A"}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>

                            {/* Order ID */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Card
                                variant="outlined"
                                sx={{ height: "100%", bgcolor: "#f8fafc" }}
                              >
                                <CardContent>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Order ID
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 600, color: "#1e293b", mt: 1 }}
                                  >
                                    {payment.order_id || "N/A"}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>

                            {/* Fees Type */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Card
                                variant="outlined"
                                sx={{ height: "100%", bgcolor: "#f8fafc" }}
                              >
                                <CardContent>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Fees Type
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 600, color: "#1e293b", mt: 1 }}
                                  >
                                    {payment.feesType || "N/A"}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>

                            {/* Total Amount */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Card
                                variant="outlined"
                                sx={{ height: "100%", bgcolor: "#f8fafc" }}
                              >
                                <CardContent>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Total Amount
                                  </Typography>
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 700,
                                      color:
                                        payment.order_status?.toLowerCase() ===
                                          "success"
                                          ? "#059669"
                                          : "#1e293b",
                                      mt: 1,
                                    }}
                                  >
                                    {payment.TotalAmount
                                      ? payment.TotalAmount
                                      : payment.amount
                                        ? payment.amount
                                        : "N/A"}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>

                          {/* Separator between payments */}
                          {index < paymentDetails.length - 1 && (
                            <Divider sx={{ mt: 3 }} />
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Paper>
                )}

              {/* No Payment Details Message */}
              {(!paymentDetails ||
                !Array.isArray(paymentDetails) ||
                paymentDetails.length === 0) &&
                feesData.summary.grandTotal > 0 && (
                  <Paper
                    sx={{
                      mt: 3,
                      p: 3,
                      backgroundColor: "#fff7ed",
                      border: "1px solid #fb923c",
                      borderRadius: 2,
                    }}
                  >
                    <Alert severity="warning" icon={<InfoIcon />}>
                      <Typography variant="body1">
                        No payment has been made for this application yet. Please
                        proceed to the Declaration section to complete the payment.
                      </Typography>
                    </Alert>
                  </Paper>
                )}

            </>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setPaymentsDialogOpen(false)} variant="contained" color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>



        {/* Form 131 Details Dialog */}
        <Dialog
          open={form131DialogOpen}
          onClose={() => setForm131DialogOpen(false)}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '90vh'
            }
          }}
        >
          <DialogTitle
            sx={{
              bgcolor: '#9c27b0',
              color: 'white',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <ReportIcon />
            Form131 Details
          </DialogTitle>

          <DialogContent sx={{ p: 3, mt: 1 }}>
            {form131Data && form131Data.length > 0 ? (
              <TableContainer component={Paper} elevation={2}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f3e5f5' }}>
                      <TableCell><b>S.No</b></TableCell>
                      <TableCell><b>Terms Check</b></TableCell>
                      <TableCell><b>Acceptance Date</b></TableCell>
                      <TableCell><b>Head Name</b></TableCell>
                      <TableCell><b>Designation</b></TableCell>
                      <TableCell><b>Action</b></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {form131Data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          {item.istermCheck === 1 ? "Yes" : "No"}
                        </TableCell>
                        <TableCell>
                          {new Date(item.acceptancedate).toLocaleDateString()}
                        </TableCell>
                        <TableCell>{item.HeadName}</TableCell>
                        <TableCell>{item.Designation}</TableCell>
                        <TableCell>
                          <Button variant="contained" size="small" onClick={() => handleClickViewTerm(item)} >
                            View
                          </Button>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography>Loading...</Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => setForm131DialogOpen(false)}
              variant="contained"
              color="secondary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>


        {/* Main Content Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Dealing Officer Details Button */}
          <Grid item xs={12} lg={4}>
            {/* Dialog for Dealing Officer Information */}
            <Dialog
              open={openOfficerDialog}
              onClose={handleCloseOfficerDialog}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle>Dealing Officer Information</DialogTitle>
              <DialogContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: "primary.main",
                      mr: 2,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <BadgeIcon />
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    Dealing Officer
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2, mb: 2 }}
                    >
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Officer Name
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.name || "Not assigned"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2, mb: 2 }}
                    >
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Email
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12}>
                    <Box sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2 }}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Contact
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.mobile ||
                          dealingOfficer?.email ||
                          "N/A"}
                      </Typography>
                    </Box>
                  </Grid> */}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseOfficerDialog}
                  color="primary"
                  variant="outlined"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          {/* Contact Person Details Button */}
          <Grid item xs={12} lg={4}>
            {/* Dialog for Contact Person Information */}
            <Dialog
              open={openContactDialog}
              onClose={handleCloseContactDialog}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle>Contact Person Information</DialogTitle>
              <DialogContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: "secondary.main",
                      mr: 2,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <BusinessIcon />
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    Laboratory Contacts
                  </Typography>
                </Box>

                {contactPersons.length > 0 ? (
                  <Grid container spacing={3}>
                    {contactPersons.map((contact, index) => (
                      <Grid item xs={12} md={12} key={index}>
                        <Card
                          variant="outlined"
                          sx={{
                            height: "100%",
                            border: contact.isPrimary
                              ? "2px solid #1976d2"
                              : "1px solid #e0e0e0",
                          }}
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 2,
                              }}
                            >
                              <Avatar
                                sx={{
                                  bgcolor:
                                    contact.recordType === "lab_head_contact"
                                      ? "primary.main"
                                      : "success.main",
                                  mr: 2,
                                  width: 32,
                                  height: 32,
                                }}
                              >
                                <Person2Outlined sx={{ fontSize: 18 }} />
                              </Avatar>
                              <Box>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {contact.recordType === "lab_head_contact"
                                    ? "Contact Person Details"
                                    : "CEO Details"}
                                </Typography>
                                {/* {contact.isPrimary && (
                                          <Chip 
                                            label="Primary" 
                                            size="small" 
                                            color="primary" 
                                            sx={{ mt: 0.5 }} 
                                          />
                                        )} */}
                              </Box>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                  fontWeight: 600,
                                  textTransform: "uppercase",
                                  letterSpacing: 0.5,
                                }}
                              >
                                Name
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500, mt: 0.5 }}
                              >
                                {contact.name || "Not available"}
                              </Typography>
                            </Box>

                            {contact.email && (
                              <Box sx={{ mb: 2 }}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Email
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, mt: 0.5 }}
                                >
                                  {contact.email}
                                </Typography>
                              </Box>
                            )}

                            {contact.mobile && (
                              <Box sx={{ mb: 2 }}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Mobile
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, mt: 0.5 }}
                                >
                                  {contact.mobile}
                                </Typography>
                              </Box>
                            )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Box sx={{ textAlign: "center", py: 3 }}>
                    <Typography variant="body1" color="text.secondary">
                      No contact information available
                    </Typography>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseContactDialog}
                  color="secondary"
                  variant="outlined"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {/* PT Plan Upload Dialog */}
            <Dialog
              open={ptPlanModalOpen}
              onClose={handleClosePTPlanModal}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CloudUploadIcon color="primary" />
                  <Typography variant="h6">Upload PT Plan</Typography>
                </Box>
              </DialogTitle>
              <DialogContent>
                <Box sx={{ my: 2 }}>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Please upload PT Plan document. Download the NABL-163 format
                    if needed.
                  </Alert>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={downloadNABLFormat}
                    sx={{ mb: 3 }}
                  >
                    Download NABL-163 Format
                  </Button>

                  <FileUploadComponent
                    key={`ptPlanFile-${fileUploadKey}`}
                    fieldName="ptPlanFile"
                    label="Upload PT Plan Document"
                    orgId={localStorage.getItem("orgId") || "laboratory"}
                    section="pt-plan-documents"
                    accept=".pdf,.doc,.docx"
                    maxSize={10}
                    onChange={handleFileUploadChange}
                    initialFile={uploadedPtPlanFile}
                    localDeleteOnly={false}
                    required={false}
                    disabled={false}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClosePTPlanModal}
                  color="secondary"
                  variant="outlined"
                  disabled={ptPlanUploading}
                >
                  Close
                </Button>
                <Button
                  onClick={() => handleManualPTPlanUpload(applicationData)}
                  color="primary"
                  variant="contained"
                  disabled={ptPlanUploading || !selectedPtPlanFile}
                  startIcon={
                    ptPlanUploading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <CloudUploadIcon />
                    )
                  }
                >
                  {ptPlanUploading ? "Uploading..." : "Upload"}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Additional Application Selection Dialog */}
            <Dialog
              open={openAdditionalAppDialog}
              onClose={handleCloseAdditionalAppDialog}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AddIcon color="primary" />
                  <Typography variant="h6">
                    Create Additional Application
                  </Typography>
                </Box>
              </DialogTitle>
              <DialogContent>
                <Box sx={{ my: 2 }}>
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel
                      component="legend"
                      sx={{ mb: 2, fontWeight: 600, color: "#333" }}
                    >
                      Select Application Type
                    </FormLabel>
                    <RadioGroup
                      value={selectedApplicationType}
                      onChange={(e) =>
                        setSelectedApplicationType(e.target.value)
                      }
                    >
                      {assessmentTypesLoading ? (
                        <Box sx={{ textAlign: 'center', py: 3 }}>
                          <CircularProgress size={30} />
                          <Typography variant="body2" sx={{ mt: 2, color: '#666' }}>
                            Loading application types...
                          </Typography>
                        </Box>
                      ) : assessmentTypes.length > 0 ? (
                        assessmentTypes.map((type) => (
                          <FormControlLabel
                            key={type.Id}
                            value={type.Id.toString()}
                            control={<Radio />}
                            label={
                              <Box>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {type.Name}
                                </Typography>
                              </Box>
                            }
                            sx={{
                              mb: 2,
                              p: 2,
                              border: "1px solid #e0e0e0",
                              borderRadius: 2,
                              "&:hover": { bgcolor: "#f5f5f5" },
                              "&:last-child": { mb: 0 },
                            }}
                          />
                        ))
                      ) : (
                        <Box sx={{ textAlign: 'center', py: 3 }}>
                          <Typography variant="body2" color="text.secondary">
                            No additional application types available
                          </Typography>
                        </Box>
                      )}
                    </RadioGroup>
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseAdditionalAppDialog}
                  color="secondary"
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApplicationTypeSelect}
                  color="primary"
                  variant="contained"
                  disabled={!selectedApplicationType}
                >
                  Continue
                </Button>
              </DialogActions>
            </Dialog>

            {/* Password Verification Dialog */}
            <Dialog
              open={openPasswordDialog}
              onClose={handleClosePasswordDialog}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle>
                <Typography variant="h6">Verify Password</Typography>
              </DialogTitle>
              <DialogContent>
                <Box sx={{ mt: 2 }}>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Please enter your password to proceed with creating the
                    additional application.
                  </Alert>
                  <TextField
                    fullWidth
                    type="password"
                    label="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handlePasswordVerification();
                      }
                    }}
                    autoFocus
                    sx={{ mt: 1 }}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClosePasswordDialog}
                  color="secondary"
                  variant="outlined"
                  disabled={creatingApplication}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => handlePasswordVerification(selectedApplicationType)}
                  color="primary"
                  variant="contained"
                  disabled={!password || creatingApplication}
                  startIcon={creatingApplication ? <CircularProgress size={20} /> : null}
                >
                  {creatingApplication ? 'Creating Application...' : 'Verify & Continue'}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Outstanding Amount Popup — no disableBackdropClick needed; use disableEscapeKeyDown + no onClose */}
            <Dialog
              open={outstandingPopupOpen}
              disableEscapeKeyDown
              maxWidth="md"
              fullWidth
              PaperProps={{ sx: { borderRadius: 2 } }}
            >
              <DialogTitle sx={{ bgcolor: '#00024c', color: 'white', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
                <PaymentIcon />
                Outstanding Payment Due
              </DialogTitle>
              <DialogContent sx={{ pt: 3 }}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  You have unpaid outstanding dues. Please clear them to continue using NABL portal services.
                </Alert>
                <TableContainer component={Paper} elevation={1}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ bgcolor: '#00024c' }}>
                        {['S.No', 'Bill Reference', 'Bill Date', 'Party Name', 'Lab ID', 'Opening Balance', 'Closing Balance', 'Due Date', 'Overdue Days', 'Payment Status'].map(h => (
                          <TableCell key={h} sx={{ fontWeight: 700, color: 'white', whiteSpace: 'nowrap' }}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {outstandingPopupData.map((row, index) => {
                        const fmtDate = (d) => {
                          if (!d) return 'N/A';
                          const [y, m, day] = d.split('-');
                          return `${day}/${m}/${y}`;
                        };
                        const fmtCurrency = (amt) => {
                          if (amt === null || amt === undefined) return '₹ 0.00';
                          return `₹ ${Number(amt).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        };
                        return (
                          <TableRow key={row.Entry_No} sx={{ bgcolor: index % 2 === 0 ? '#f5f5f5' : 'white' }}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>{row.Billreference}</TableCell>
                            <TableCell>{fmtDate(row.BillDate)}</TableCell>
                            <TableCell>{row.BillPartyName}</TableCell>
                            <TableCell>{row.Labid}</TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>{fmtCurrency(row.BillOpeningBalance)}</TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>{fmtCurrency(row.BillClosingBalance)}</TableCell>
                            <TableCell>{fmtDate(row.BillDueOn)}</TableCell>
                            <TableCell>
                              <Chip
                                label={`${row.BillOverDueDays} days`}
                                size="small"
                                color={row.BillOverDueDays > 30 ? 'error' : row.BillOverDueDays > 0 ? 'warning' : 'success'}
                              />
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={row.PaymentStatus || 'Not Paid'}
                                size="small"
                                color={row.PaymentStatus === 'Paid' ? 'success' : 'error'}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      <TableRow sx={{ bgcolor: '#e3f2fd' }}>
                        <TableCell colSpan={6} sx={{ fontWeight: 700, textAlign: 'right', fontSize: '1rem' }}>Net Total (Closing Balance):</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: outstandingPopupTotal > 0 ? '#d32f2f' : '#2e7d32' }}>
                          ₹ {Number(outstandingPopupTotal).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell colSpan={3} />
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </DialogContent>
              <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
                <Button
                  variant="text"
                  onClick={handleSkipOutstanding}
                  sx={{ color: '#666' }}
                >
                  Skip for Now
                </Button>
                <Button
                  variant="contained"
                  startIcon={<PaymentIcon />}
                  disabled={outstandingPaymentLoading}
                  onClick={handlePayOutstanding}
                  sx={{ bgcolor: '#E34124', '&:hover': { bgcolor: '#c73518' }, fontWeight: 700, px: 4 }}
                >
                  {outstandingPaymentLoading
                    ? 'Processing...'
                    : `Pay Now — ₹ ${Number(outstandingPopupTotal).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Enhanced PDF Viewer for Preview Reports */}
            <PreviewReportPDFViewer
              open={pdfViewerOpen}
              onClose={() => setPdfViewerOpen(false)}
              pdfUrl={pdfUrl}
              reportTitle="Preview Report"
              loading={pdfLoading}
              error={pdfError}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DashboardPage_new;
